<!--
2021-07-06 CHP 增加withdraw实名认证相关逻辑
2022-01-26 CHP 双账号
2022-02-17 CHP 支持多国家、多货币(充值、提款、认证)
-->
<template>
  <div>
    <div class="accountPage" v-if="mounted" id="accountPage">
      <TopBack v-if="0" :title="topTitle"/>
      <div class="tabList">
        <div
          class="tab"
          :class="{'tabSelected': $route.name.startsWith(item.key)}"
          v-for="(item, index) in tabList"
          :key="index"
          @click="selectTab(item.key)">
          {{ item.label }}
        </div>
      </div>
      <div class="waringBox">
        <div
          v-if="warningShow&&($route.name === 'Deposit'&&gatewayList&&gatewayList.length>0)"
          class="warning">
          <!--        {{ WarningEN }}-->
          {{ $store.state.locale === 'EN' ? WarningEN : WarningIN }}
        </div>
      </div>
      <div class="waringBox">
        <div
          v-if="WithdrawwarningShow&&$route.name === 'Withdraw'"
          class="warning">
          {{ $store.state.locale === 'EN' ? WithdrawableWarningEN : WithdrawableWarningIN }}
        </div>
      </div>
      <div class="tabContainer">
        <div class="account" v-if="$route.name === 'Account'">
          <div class="row">
            <div class="caption">
              <span>{{ $t('lang.account.totalBalance') }}</span>
            </div>
            <div class="inputRow" style="display: flex;justify-content: flex-end;padding-right: 15px">
                <span class="money">
                  <span class="spanShow">{{
                      fetchCurrency[userInfo.CurrencyName]
                    }}{{
                      separateThousand(balance)
                    }}</span>
                  <span class="spanHide">{{
                      fetchCurrency[userInfo.CurrencyName]
                    }}{{
                      separateThousand(balance)
                    }}</span>
                  <div class="refresh" v-cool:1800="refreshBalance"><img :src="fresh" alt=""/></div>
                </span>
            </div>
            <div class="secondaryRow">
            <span class="title">
              {{ $t('lang.account.withdrawableBalance') }}:
            </span>
              <span class="amount">
              {{ fetchCurrency[userInfo.CurrencyName] }}{{ separateThousand(this.accountInfo.WithdrawableCash) }}
            </span>
            </div>
          </div>
          <div class="row">
            <div class="btnRow">
              <div class="depositBtn" @click="selectTab('Deposit')">{{ $t('lang.account.deposit') }}</div>
              <div class="withdrawBtn" @click="selectTab('Withdraw')">{{ $t('lang.account.withdraw') }}</div>
            </div>
          </div>
          <div class="row" style="margin-top: 20px">
            <div class="text-line">
              <span>{{ $t('lang.account.cash') }}</span>
              <span class="right-text">{{ separateThousand(cw) }}</span>
            </div>
            <div class="text-line">
              <span>{{ $t('lang.account.transferAcc') }}</span>
              <span class="right-text">{{ separateThousand(accountInfo.TransferAmount) }}</span>
            </div>
            <div class="text-line">
              <span>{{ $t('lang.account.transferAccProcess') }}</span>
              <span class="right-text">{{ separateThousand(accountInfo.W9ProcessingAmount) }}</span>
            </div>
            <div class="text-line">
              <span>{{ $t('lang.history.Gift') }}</span>
              <span class="right-text">{{ separateThousand(accountInfo.Gift) }}</span>
            </div>
          </div>
        </div>
        <div class="deposit" v-if="$route.name === 'Deposit'&&gatewayList&&gatewayList.length>0">
          <UpiInfoPop v-if="UpiInfoPopShow" @close="UpiInfoPopShow=false" @commitUPIInfo="commitUPIInfo"></UpiInfoPop>
          <BankCardInfoPop v-if="BankCardInfoPopShow"></BankCardInfoPop>
          <BankTransferInfoPop v-if="BankTransferInfoPopShow"
                               @close="BankTransferInfoPopShow=false"></BankTransferInfoPop>
          <div class="row r325">
            <div class="nav">
              <!--              <div class="new" v-if="gatewayTypes&&gatewayTypes.length>1"><img :src="newIcon"/></div>-->
              <div class="nav-item" v-for="(item, index) in gatewayTypes" :key="index"
                   :class="{'active':depositNav === item.GatewayType}"
                   @click="selectDepositTab(item.GatewayType)">
                <span>{{ item.GatewayType }}</span>
                <div class="activeEvent" v-if="activeEventOfNav(item.GatewayType)">{{
                    $t('lang.depositBonus.ActiveEvent')
                  }}
                </div>
              </div>
            </div>
            <div class="gateways-by-type" v-for="(tpeItem, index) in gatewayTypes" :key="index"
                 :class="{'gateways-by-type-active':depositNav === tpeItem.GatewayType}">
              <div class="gatewayRow">
                <div class="gatewayItem" style="width: 45.56vw"
                     v-for="(item, index) in gatewayListByType" :key="index">
                  <div class="gatewayRadio" @click="fetchTransaction(item)">
                    <input :id="'rd' + index" type="radio" style="height: 4vw;width: 4vw" :value="item"
                           v-model="selectedGateway" v-show="false"/>
                    <div class="inlineDiv" :class="{activeDiv: selectedGateway.Name===item.Name}">
                      <label :for="'rd' + index" class="gatewayTxt">{{
                          item.AnotherName ? item.AnotherName : $t('lang.account.gateway') + '#' + item.No
                        }}</label>
                      <div class="activeEvent"
                           v-if="DepositGatewayActivity&&DepositGatewayActivity.length>0&&DepositGatewayActivity.includes(item.Name)"
                           style="right: -8vw">{{ $t('lang.depositBonus.ActiveEvent') }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="how2UseUpi" v-if="depositNav.toLowerCase() === 'usdt'">
                <img :src="question" @click="openHowToUSDTPop">
                <div @click="openHowToUSDTPop">{{ $t('lang.usdt.how') }}</div>
              </div>
              <div class="how2UseUpi" v-if="depositNav.toLowerCase()==='bank card'">
                <img :src="question" @click="how2UseUpi" alt="">
                <div @click="how2UseUpi">{{ $t('lang.upi.how') }}</div>
              </div>
              <div class="howtoDeposit" v-if="false">
                Tips: How to deposit?&nbsp;&nbsp;<a @click="showDepositStep = true">click</a></div>
              <div class="depositWord">
                <span>{{ $t('lang.account.amount') }}</span>
                <div class="upiTeachingIcon" v-if="$route.name === 'Deposit'&&UpiUser&&UpiUser.ActivitySwitch===true"
                     @click="UpiIconClick">
                  <div class="img">
                    <div class="redPoint" v-if="UpiUser.RedDot===true"/>
                    <img :src="upiTeachingIcon" alt=""/>
                  </div>
                </div>
              </div>
              <div class="depositRow" v-for="(item, index) in selectedGateway.DepositRange" :key="index"
                   v-if="gatewayListByType.length > 0 && selectedGateway.Name != 'CoinsPay'&&judgeRow(item)">
                <div
                  class="depositItem"
                  v-for="(amount, indx) in item"
                  :key="index + '_' + indx"
                  :class="{'deposit-selected': amount === depositAmount}"
                  v-if="fetchRange(amount, 'deposit')"
                  @click="fetchAmount(amount, 'deposit', index, indx)"
                >
                  <div
                    :class="changeDepositRangeBg(index)"
                    v-if="selectedGateway.DepositDiscountRange && selectedGateway.DepositDiscountRange[index] && selectedGateway.DepositDiscountRange[index][indx]"
                  >
                    +{{ selectedGateway.DepositDiscountRange[index][indx] }}
                  </div>
                  <div v-else class="discountRange" style="background: none;"></div>
                  <span>
                  {{ separateThousandInteger(amount) }}
                </span>
                </div>
              </div>
            </div>
            <div class="compute-deposit-discount" v-show="false" v-if="gatewayListByType.length > 0">
              <table cellspacing="1px" class="depositTotalTable">
                <tr>
                  <td>{{ $t('lang.account.cash') }}</td>
                  <td></td>
                  <td>{{ $t('lang.account.bonus') }}</td>
                  <td></td>
                </tr>
                <tr>
                  <td v-if="depositNav.toLowerCase() === 'usdt'">{{ computedAmount() }}</td>
                  <td v-else>{{ depositCashBonus.amount }}</td>
                  <td>+</td>
                  <td>{{ depositCashBonus.cash }}</td>
                  <td v-if="depositNav.toLowerCase() === 'usdt'">= {{ computedTotal() }}</td>
                  <td v-else>= {{ depositCashBonus.total }}</td>
                </tr>
              </table>
            </div>
            <div class="bonus">{{ $t('lang.account.bonus') }}</div>
            <div class="discountTypeChoose">
              <div class="choose" v-show="!showUpiHelpPop">
                <div class="discountName">{{ discountName }}</div>
                <div class="chooseDrop"><img :src="chooseDrop" alt="chooseDrop"/></div>
                <div class="mask" @click="showTypeDrop"/>
                <div class="typeDropList" v-if="typeDropShow">
                  <div class="item"
                       :class="judgeActive(item)?'active':''"
                       v-for="(item,index) in discounts" :key="index" @click="chooseDiscountType(item)">{{ item.name }}
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div class="deposit-step" v-if="showDepositStep">
                <div class="cancel-btn" v-show="tipsDelayAwhile" @click="closeDepositStep">
                  <img style="width: 40px;"
                       src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzgiIGhlaWdodD0iMzgiIHZpZXdCb3g9IjAgMCAzOCAzOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTguOTk2IDQuNzEyODlDMTEuMTEzNCA0LjcxMjg5IDQuNzEyODkgMTEuMTEzMyA0LjcxMjg5IDE4Ljk5NjZDNC43MTI4OSAyNi44Nzk5IDExLjExMzQgMzMuMjgwMyAxOC45OTYgMzMuMjgwM0MyNi44ODEgMzMuMjgwMyAzMy4yNzkzIDI2Ljg3OTkgMzMuMjc5MyAxOC45OTY2QzMzLjI3OTMgMTEuMTEzMyAyNi44ODEgNC43MTI4OSAxOC45OTYgNC43MTI4OVpNMTguOTk2IDYuNjEyODlDMjUuODMxMyA2LjYxMjg5IDMxLjM3OTMgMTIuMTYxOCAzMS4zNzkzIDE4Ljk5NjZDMzEuMzc5MyAyNS44MzEzIDI1LjgzMTMgMzEuMzgwMyAxOC45OTYgMzEuMzgwM0MxMi4xNjA4IDMxLjM4MDMgNi42MTI4OSAyNS44MzEzIDYuNjEyODkgMTguOTk2NkM2LjYxMjg5IDEyLjE2MTggMTIuMTYwOCA2LjYxMjg5IDE4Ljk5NiA2LjYxMjg5WiIgZmlsbD0iI0Y2RDlBQSIgZmlsbC1vcGFjaXR5PSIwLjYiLz4NCjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMjUuNDUzMiAxMS4yMTA4TDExLjIyNDQgMjUuNDM5N0MxMC44NTM2IDI1LjgxMDUgMTAuODUzMiAyNi40MTIgMTEuMjI0NCAyNi43ODMyQzExLjU5NTUgMjcuMTU0MyAxMi4xOTcxIDI3LjE1NCAxMi41Njc5IDI2Ljc4MzJMMjYuNzk2OCAxMi41NTQzQzI3LjE2NzQgMTIuMTgzNyAyNy4xNjc5IDExLjU4MiAyNi43OTY4IDExLjIxMDhDMjYuNDI1NiAxMC44Mzk3IDI1LjgyMzkgMTAuODQwMiAyNS40NTMyIDExLjIxMDhaIiBmaWxsPSIjRjZEOUFBIiBmaWxsLW9wYWNpdHk9IjAuNiIvPg0KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yNi43ODkyIDI1LjQzNDdMMTIuNTYwMyAxMS4yMDU4QzEyLjE4OTUgMTAuODM1IDExLjU4OCAxMC44MzQ3IDExLjIxNjggMTEuMjA1OEMxMC44NDU3IDExLjU3NyAxMC44NDYgMTIuMTc4NSAxMS4yMTY4IDEyLjU0OTNMMjUuNDQ1NyAyNi43NzgyQzI1LjgxNjMgMjcuMTQ4OCAyNi40MTggMjcuMTQ5MyAyNi43ODkyIDI2Ljc3ODJDMjcuMTYwMyAyNi40MDcxIDI3LjE1OTggMjUuODA1MyAyNi43ODkyIDI1LjQzNDdaIiBmaWxsPSIjRjZEOUFBIiBmaWxsLW9wYWNpdHk9IjAuNiIvPg0KPC9zdmc+DQo="
                       alt="">
                </div>
                <div class="deposit-step-img">
                  <img :src="DepositStepImg"/>
                </div>
              </div>
            </div>
          </div>
          <div class="totalGet mt16">{{ $t('lang.account.total') }}</div>

          <div class="totalGet" v-if="depositNav.toLowerCase() === 'usdt'">{{ $t('lang.account.currencyType') }}{{
              separateThousandInteger(computedTotal())
            }}
          </div>
          <div class="totalGet" v-else>{{ $t('lang.account.currencyType') }}{{
              separateThousandInteger(depositCashBonus.total)
            }}
          </div>
          <div class="USDTTip" v-if="depositNav.toLowerCase() === 'usdt'">
            <div class="title">{{ $t('lang.account.notice') }}</div>
            <div class="rules" v-html="getUSDTTip($t('lang.account.USDTTip'))"></div>
          </div>
          <div class="submit" @click="handleDeposit" v-if="selectedGateway.Name != 'CoinsPay'">
            {{ $t('lang.menu.Deposit') }} <span v-if="depositNav.toLowerCase() !== 'usdt'">{{
              $t('lang.account.currencyType')
            }}</span><span
            v-if="depositNav.toLowerCase() === 'usdt'">{{ depositCashBonus.amount }}U</span><span
            v-else>{{ separateThousandInteger(depositCashBonus.amount) }}</span>
          </div>
          <!--          <div class="carlousel">-->
          <!--            <DWCarousel>-->
          <!--            </DWCarousel>-->
          <!--          </div>-->
        </div>
        <div class="withdraw" v-if="$route.name === 'Withdraw'">
          <div class="balanceBox">
            <div class="historyPropBtn" @click="goHistory">
              {{ $t('lang.WithdrawalSuccessful.history') }}>
            </div>
            <div class="balance-caption">
              {{ $t('lang.account.withdrawableBalance') }}
            </div>
            <div class="cashCount">
                <span class="money2"><span class="spanShow">{{
                    fetchCurrency[userInfo.CurrencyName]
                  }}{{
                    separateThousand(withdrawBalance)
                  }}</span>
                  <span class="spanHide">{{
                      fetchCurrency[userInfo.CurrencyName]
                    }}{{
                      separateThousand(accountInfo.WithdrawableCash)
                    }}</span>
                    <div class="refresh" v-cool:1800="refreshWithDraw"><img :src="fresh" alt=""/></div>
                </span>
            </div>
            <div
              class="gift-prompt"
              v-if="this.accountInfo.Gift > 0"
              v-html="$t('lang.account.betThenWithdraw', {
            bet: `${fetchCurrency[userInfo.CurrencyName]}${separateThousand(this.accountInfo.BetingToConvertToWithdrawableCash + this.accountInfo.Cash)}`,
            withdraw: `${fetchCurrency[userInfo.CurrencyName]}${separateThousand(this.accountInfo.Gift + this.accountInfo.Cash)}`
          })"
            >
            </div>
          </div>

          <div class="row" style="margin-top: 20px">
          </div>
          <div class="row" style="text-align: right"
               v-if="$store.state.verifyInfo && activeBankAccount&&activeBankAccount.BankCardVerifyStatus < 20 && $store.state.verifyInfo.BankMessage">
            <span class="audit-message">{{ $store.state.verifyInfo.BankMessage }}</span>
          </div>
          <div class="caption">
            {{ $t('lang.account.amount') }}
          </div>
          <div class="tips">
            {{ $t('lang.account.selectAmount') }}
          </div>
          <div class="row">
            <div class="inputRow" v-for="(item, index) in withdrawAmountList" :key="index">
              <div
                v-for="amount in item"
                :key="amount"
                :class="{'selected': amount === withdrawAmount}"
                @click="fetchAmount(amount, 'withdraw')"
              >
                {{ separateThousandInteger(amount) }}
              </div>
            </div>
          </div>
          <div class="splitWithdrawBox" v-if="withdrawAmount >= SplitThreshold">
            <div class="splitWithdrawTipBox">
              <div class="splitWithdrawTip">{{ $t('lang.account.splitWithdrawTip') }}</div>
              <img tabindex="0" @focus="splitWithdrawTipContentBoxShow = true"
                   @blur="splitWithdrawTipContentBoxShow = false"
                   src="../../assets/images/account/splitWithDrawIsIcon.png" alt="" class="splitWithdrawTipIcon">
              <div class="splitWithdrawTipContentBox" :style="{ right: lang === 'EN' ? '7.8vw' : '0' }"
                   v-if="splitWithdrawTipContentBoxShow">
                <div class="arrowIcon"></div>
                {{ $t('lang.account.splitWithdrawTipContent') }}
              </div>
            </div>
            <div class="splitWithdrawOptionBox">
              <div class="withdrawOptionItem" @click="activeSplitWithdrawOption(0)">
                <div class="withdrawOptionItemCard"
                     :style="`background-image:url(${splitWithdrawOptionItemActive === 0 ? withdrawOptionItemBgActive: withdrawOptionItemBg});`">
                  <img :src="withdrawOptionItemCardIcon1" alt="" style="height: 5.494vw;width: 5.494vw;"
                       class="withdrawOptionItemCardIcon">
                  <div class="contentBox">
                    <div class="title">{{ $t('lang.account.withdrawing') }} <span>₹{{ withdrawAmount }}</span></div>
                    <div class="largeWithdrawalsItemTip">{{ $t('lang.account.largeWithdrawalsItemTip') }}</div>
                  </div>
                </div>
                <div class="optionItemCardCheckIcon">
                  <div class="checked" v-if="splitWithdrawOptionItemActive === 0"></div>
                </div>
              </div>
              <div class="withdrawOptionItem" @click="activeSplitWithdrawOption(1)">
                <div class="withdrawOptionItemCard"
                     :style="`background-image:url(${splitWithdrawOptionItemActive === 1 ? withdrawOptionItemBgActive2: withdrawOptionItemBg2});`">
                  <img :src="withdrawOptionItemCardIcon2" alt="" class="withdrawOptionItemCardIcon">
                  <div class="contentBox">
                    <div class="title">{{ $t('lang.account.withdrawing') }}
                      <span>₹{{ getSplitWithdrawAmount(withdrawAmount) }}</span></div>
                    <div class="largeWithdrawalsItemTip">{{ $t('lang.account.withdrawalsAsterItemTip') }}</div>
                  </div>
                </div>
                <div class="optionItemCardCheckIcon">
                  <div class="checked" v-if="splitWithdrawOptionItemActive === 1"></div>
                </div>
                <div class="recommendBox">
                  <img src="../../assets/images/account/recommendIcon.png" alt="" class="recommendIcon">
                  <div class="recommend">{{ $t('lang.account.recommend') }}</div>
                </div>
              </div>
            </div>
          </div>
          <!-- 2022-1-12 LBL 修改warning为文字链接，点击弹出withdrawal rule 弹窗 -->
          <div class="tips warnings pointer" @click="showWithdrawalRules" style="margin-top: 3.055vw">
            {{ $t('lang.account.withdrawalRules') }}
          </div>
          <div class="submit" style="margin-bottom: 12vw" @click="isMondayOrWeekend()">{{
              $t('lang.account.submit')
            }}
          </div>
          <div class="withdrawSetupBoxMask" v-if="withdrawSetup">
            <!--            <img src="../../assets/images/WithdrawalSuccessful/close.png" @click="withdrawSetup = ''" alt="" :class="getWindowHeight===1 ? 'close' : 'close2'">-->
            <div class="withdrawSetupBox">
              <Setup :withdrawAmount="withdrawAmount" :selectTab="selectTab" @doWithdraw="doWithdraw"
                     @close="withdrawSetup = ''" :withdrawFee="withdrawFee" @openDeatilShow="openDeatilShow"
                     :setupType="withdrawSetup"
                     :parentChoose="chooseCard" :handelBack="()=>{this.withdrawSetup=''}"/>
            </div>
          </div>
          <div class="withdrawBanner" v-if="0">
            <img src="" alt="NOT IMAGE! PLEASE UPLOAD IMAGE!">
          </div>
        </div>
      </div>
      <form ref="form" :action="GladPayUrl" method="post" v-show="0">
        <input type="hidden" v-for="(key, index) in Object.keys(formData)" :key="index" :name="key"
               :value="formData[key]">
      </form>
      <div class="maskBg" v-show="showPopMessage2">
        <div class="pop-message-wrapper2">
          <ul class="pop-message-content">
            <p v-html="popMessage2"></p>
            <div class="close-pop-message">
              <span class="close-pop-btn" @click="closeDepositMsgPop2">{{ $t('lang.common.ok') }}</span>
            </div>
          </ul>

        </div>
      </div>
      <div class="usdtGuide" v-if="usdtGuide&&depositNav.toLowerCase() === 'usdt'">
        <div class="usdt_Pop">
          <div class="title" v-html="$t('lang.account.usdtPopTitle')"/>
          <div class="btn" @click="doDeposit()">{{ $t('lang.messageBox.ok') }}</div>
        </div>
      </div>
      <UpiActivity
        v-show="UpiActivityShow"
        :goToUpiTeaching="UpiPopGoClick"
        :handleClose="closeUpiActivityShow"
      />
      <TeachingPop
        v-if="TeachingPopShow"
        :handleClose="closeTeaching"
        :finishUpiStudy="finishUpiStudy"
      />
      <howToUseUSDTPop
        v-if="howToUseUSDTPopShow"
        @handleClose="closeHowToUseUSDTPop"
      />
      <UpiGiftReward
        v-if="showUpiGiftReward"
        :handleClose="closeUpiGiftReward"
        :btnText="this.$t('lang.upiTeaching.button' + this.teachingAlertMode)"
        :nextToDo="UpiGiftRewardToDo"
      >
        <div class="slots">
          <div class="title" v-if="teachingAlertMode!==3" v-for="(title,index) in $t('lang.upiTeaching.title')"
               :key="index">
            {{ title }}
          </div>
          <div class="reward" v-if="teachingAlertMode!==3">
            {{ $t('lang.account.currencyType') }}{{ separateThousand(UpiUser.Reward) }}
          </div>
          <div class="desc" v-if="teachingAlertMode===1"
               v-html="$t('lang.upiTeaching.desc').replace('{amount}',UpiUser.Target)"/>
          <div class="sentence" v-if="teachingAlertMode===3" v-html="$t('lang.upiTeaching.sentence')"/>
        </div>
      </UpiGiftReward>
      <VersionUpdatePop v-show="showUpgradePop"
                        promptType="2"
                        :handleClose="closeUpgrade"></VersionUpdatePop>
      <UpiHelpPop v-show="showUpiHelpPop"
                  :handleClose="closeUpiHelp"></UpiHelpPop>
      <ConfirmWin v-if="this.$store.state.confirmWinShow"
                  :hintText="withdrawConfirmText"
                  :okText="$t('lang.account.yesWithdraw')"
                  :cancelText="$t('lang.account.noWithdraw')"
                  :confirmToDo="confirmWithDraw"></ConfirmWin>
      <splitWithdrawConfirmPop
        :close="closeSplitWithdrawConfirmPop"
        @setSplitWithdrawOptionItemActive="setSplitWithdrawOptionItemActive"
        :withdrawAmount="withdrawAmount"
        :SplitAmount="SplitAmount"
        v-if="splitWithdrawConfirmPopShow"
        :withDraw="confirmWithDraw"
      ></splitWithdrawConfirmPop>
      <ConfirmAlert
        v-if="payRuAlertShow"
        :title="$t('lang.account.requirement')"
        :hintText="$t('lang.account.alertTips')"
        :okText="$t('lang.account.iSee')"
        :cancelText="$t('lang.account.noWithdraw')"
        :confirmToDo="closePayRu"
      />
      <WaitModal
        ref="waitModal"
        v-show="$store.state.waitShow"
        @closed="onModalClose"
        @navigate="proceedToNextRoute"
        :userInfo="userInfo"
      />
      <GatewayError ref="GatewayError"
                    v-show="gatewayErrorShow"
                    :handleClose="closeGatewayError"
                    :doNewOrder="doNewOrder"
                    :retryMsg="retryObject.RetryMsg"
                    :newOrderShow=false
      />
      <!--                    :newOrderShow="retryObject&&retryObject.Gateway"-->
      <Alert2
        ref="Alert2"
        v-if="showBindMobileAlert"
        :yesText="$t('lang.luckyWheel.executeBtn')"
        :closeText="$t('lang.luckyWheel.cancel')"
        :text="$t('lang.setting.bindFirst')"
        :closeClick="closeBindMobile"
        :yesClick="gotoEdit"
      />
      <!--      周一周末不提款提示框-->
      <div class="noWithdrawalsOnWeekendsMarsk" v-if="mondayOrWeekendPopShow">
        <div class="noWithdrawalsOnWeekendsPop">
          <div class="noWithdrawalsOnWeekendsPopTitle">{{ $t('lang.account.noWithdrawalsOnWeekendsPopTitle') }}</div>
          <div class="ConfirmWithdrawal" @click="handleWithdraw()">{{ $t('lang.account.ConfirmWithdrawal') }}</div>
          <div class="Cancel" @click="mondayOrWeekendPopShow = false">{{ $t('lang.account.Cancel') }}</div>
        </div>
      </div>

      <div class="pop-message-wrapper" v-show="showPopMessage">
        <div class="pop-message-content">
          <p v-html="popMessage"></p>
          <div class="close-pop-message">
                          <span class="close-pop-btn" @click="showPopMessage=false"
                                v-show="popType !== 2">{{ $t('lang.common.cancel') }}</span>
            <span class="close-pop-btn" @click="closeDepositMsgPop">{{ $t('lang.common.ok') }}</span>
          </div>
        </div>

      </div>

      <!-- payFuture 通道充值提示语-->
      <div class="payFutureMsg" v-if="payFutureMsgShow">
        <div class="msgCard">
          <div class="msg">{{ $t('lang.account.payFutureMsg1') }}</div>
          <div class="msg">{{ $t('lang.account.payFutureMsg2') }}</div>
          <div class="button" @click="closePayFutureMsg">{{ $t('lang.inviteFriends.close') }}</div>
        </div>
      </div>
    </div>
    <div class="deatilMask" v-if="deatilShow">
      <div class="deatilBox">
        <div class="title">{{ $t('lang.WithdrawalSuccessful.detail') }}</div>
        <div class="contentBox" v-html="formatterRuleContent(detailContent)">
        </div>
        <div class="cancel" @click="deatilShow = false">{{ $t('lang.common.cancel') }}</div>
      </div>
    </div>
    <div class="QRCodeMask" v-if="QRCodeShow">
      <div class="QRCodeBox">
        <div class="title">{{ $t('lang.common.ScanPay') }}</div>
        <div class="tipBox">{{ $t('lang.common.ScanPayTip') }}</div>
        <div class="QRCodeImgBox">
          <img :src="QRCode" alt="" class="QRCode">
        </div>
        <div class="PaymentOnceOnly">{{ $t('lang.common.PaymentOnceOnly') }}</div>
        <img @click="QRCodeShow = false" src="../../assets/images/account/close.png" alt="" class="close">
      </div>
    </div>
    <div class="McPayRemiderMask" v-if="McPayRemiderShow">
      <div class="McPayRemiderPop">
        <div class="title">{{ $t('lang.common.Reminder') }}</div>
        <div class="describe">{{ $t('lang.common.McPayRemiderPopDescribe') }}</div>
        <div class="optionBox">
          <div class="helpBtn systemConfirmBtn" @click="handleOpenChat">{{ $t('lang.common.Help') }}</div>
          <div class="newOrderBtn systemConfirmBtn" @click="goNewOrder()">{{ $t('lang.common.NewOrder') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UpiGiftReward from '@/components/UpiGiftReward/index'
import TeachingPop from '@/components/UPITeaching/index'
import upiTeachingIcon from '@/assets/images/account/UPPayTeachingIcon.gif'
import UpiActivity from '@/components/UpiActivityPop/index'
import {Loadmore, Toast} from 'mint-ui'
import Setup from '@/components/WithdrawSetup/index'
import WithdrawalRule from '@/components/WithdrawalRules/index'
import WaitModal from '@/components/WaitModal/index'
import GatewayError from '@/components/GatewayError/index'
import {mapMutations} from 'vuex'
import {
  separateThousand,
  getUTCNow,
  separateThousandInteger,
  LogUtils,
  fetchBalance,
  fbListener,
  adListener
} from '@/utils'
import {fetchCurrency, InternationWithdrawAmountRange} from '@/constant'
import request from '@/service'
import fire from '@/assets/images/account/fire.svg'
import fresh from '@/assets/images/account/fresh.svg'
import question from '@/assets/images/account/question.svg'
import newIcon from '@/assets/images/account/new.svg'
import showMore from '@/assets/images/common/showMore.gif'
import ok from '@/assets/images/common/ok.svg'
import warn from '@/assets/images/common/warn.svg'
import whatsapp from '@/assets/images/common/whatsapp.svg'
import copyLink from '@/assets/images/common/copylink.svg'
import UpiHelpPop from '@/components/UpiHelpPop/index'
import VersionUpdatePop from '@/components/VersionUpdatePop/index'
import transfer from '@/assets/images/account/transfer.png'
import transfer2 from '@/assets/images/account/transfer2.png'
import circule from '@/assets/images/account/circule.png'
// import DWCarousel from '@/components/GatewayWithdrawCarousel/index'
import DepositStepImg from '@/assets/images/account/deposit_steps.jpg'
import TopBack from '@/components/TopBack/index'
import gatewayHot from '@/assets/images/gateway/gatewayHot.svg'
import ConfirmWin from '@/components/ConfirmWin/confirmWithTwoButton'
import ConfirmAlert from '@/components/ConfirmWin/Alert'
import Alert2 from '@/components/ConfirmWin/Alert2'
import chooseDrop from '@/assets/images/account/chooseDrop.svg'
import UpiInfoPop from '@/components/UpiInfoPop'
import BankCardInfoPop from '@/components/BankCardInfoPop'
import BankTransferInfoPop from '@/components/BankTransferInfoPop'
import howToUseUSDTPop from '../../components/howToUseUSDTPop/index.vue'
import withdrawOptionItemBg from '@/assets/images/account/withdrawOptionItemBg.png'
import withdrawOptionItemBg2 from '@/assets/images/account/withdrawOptionItemBg2.png'
import withdrawOptionItemBgActive from '@/assets/images/account/withdrawOptionItemBgActive.png'
import withdrawOptionItemBgActive2 from '@/assets/images/account/withdrawOptionItemBgActive2.png'
import withdrawOptionItemCardIcon1 from '@/assets/images/account/withdrawOptionItemCardIcon1.png'
import withdrawOptionItemCardIcon2 from '@/assets/images/account/withdrawOptionItemCardIcon2.png'
import splitWithdrawConfirmPop from '@/components/SplitWithdrawConfirm'

export default {
  name: 'Account',
  data () {
    return {
      cw: 0,
      balance: 0,
      withdrawBalance: 0,
      usdtGuide: false,
      howToUseUSDTPopShow: false,
      McPayRemiderShow: false,
      withdrawOptionItemBg,
      withdrawOptionItemBg2,
      withdrawOptionItemBgActive,
      withdrawOptionItemBgActive2,
      withdrawOptionItemCardIcon1,
      withdrawOptionItemCardIcon2,
      splitWithdrawTipContentBoxShow: false,
      splitWithdrawOptionItemActive: 1,
      splitWithdrawConfirmPopShow: false,
      QRCodeShow: false,
      QRCode: null,
      mondayOrWeekendPopShow: false,
      payFutureMsgShow: false,
      UpiInfoPopShow: false,
      BankTransferInfoPopShow: false,
      BankCardInfoPopShow: false,
      deatilShow: false,
      detailContent: '',
      ConfigList: [],
      lang: localStorage.getItem('locale'),
      gatewayErrorShow: false,
      retryObject: {},
      leaveToRoute: '',
      waitPopShow: false,
      DepositGatewayActivity: [],
      discountTimeInterval: null,
      discountName: '',
      discounts: [],
      activity: {},
      IsLastUsed: -1,
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      showTab: 'Account',
      firstDepositGiftRatio: 0,
      firstDepositMaxGift: 0,
      discountType: 'normal_deposit',
      topTitle: this.$t('lang.menu.' + this.$route.name),
      tabList: [
        {
          label: this.$t('lang.account.wallet'),
          key: 'Account'
        },
        {
          label: this.$t('lang.account.deposit'),
          key: 'Deposit'
        },
        {
          label: this.$t('lang.account.withdraw'),
          key: 'Withdraw'
        }
      ],
      accountInfo: {},
      bonusClaim: '',
      withdrawAmountList: [],
      depositAmount: 0,
      VpaAddress: undefined,
      withdrawAmount: 0,
      SplitAmount: 10000,
      SplitThreshold: 30000,
      depositRange: {
        Min: 0,
        Max: 0
      },
      withdrawRange: {
        Min: 0,
        Max: 0
      },
      rates: '-',
      bonusCheck: true, // 2022-02-19 CHP 默认改为选中，加强Bonus的推广效果
      agreeCheck: true,
      mounted: false,
      showUpiHelpPop: false,
      fetchCurrency,
      InternationWithdrawAmountRange,
      getUTCNow,
      GladPayUrl: '',
      formData: {},
      fetchBalance,
      separateThousand,
      separateThousandInteger,
      newIcon,
      fire,
      fresh,
      question,
      showMore,
      firstRewardLoad: true,
      firstReferralLoad: true,
      referralList: [],
      withdrawSetup: '',
      claimBonus: false,
      ok: ok,
      warn: warn,
      whatsapp: whatsapp,
      copyLink: copyLink,
      minDeposit: null,
      minDepositCids: null,
      minDepositIndex: null,
      gatewayList: [],
      gatewayTypes: [], // 支付网关类型 by HHY 20220609
      gatewayListByType: [],
      selectedGateway: '', // 选择的支付网关
      showPopMessage: false,
      showPopMessage2: false,
      popMessage: '',
      popMessage2: '',
      feeFreeStatus: 0,
      withdrawFee: 0,
      showUpgradePop: false,
      popType: 0, // 0: 支付请求之前 1: 支付请求之后,
      showWithdrawalRule: false,
      transfer,
      transfer2,
      circule,
      chooseDrop,
      typeDropShow: false,
      freshNav: true,
      depositNav: '', // 选择Gatewaytype的tab时用
      depositCashBonus: { // 当充值点击充值额度时，计算充值返利和奖金 By HHY 2022-08-16
        amount: 0,
        cash: 0,
        // bonus: 0,
        total: 0
      },
      showDepositStep: false, // 是否显示充值步骤引导图
      DepositStepImg,
      cashUpPerc: 0, // 充值优惠比例
      gatewayHot,
      tipsDelayAwhile: false, // 充值提示弹图
      isFromPromotionUpiGuide: false,
      waitingGatewaysInterval: null,
      isFirstDeposit: false, // 首充50%现金奖励用 2022-10-23 HHY
      withdrawConfirmText: '',
      activeCardId: -1,
      activeBankAccount: null,
      WarningEN: '',
      WarningIN: '',
      WithdrawableWarningEN: '',
      WithdrawableWarningIN: '',
      warningShow: false,
      WithdrawwarningShow: false,
      payRuAlertShow: false,
      upiTeachingIcon,
      TeachingPopShow: false,
      teachingAlertMode: 1, // 1 已学习未达到充值目标 2 待领取 3已领取
      UpiUser: {
        ActivitySwitch: false,
        ForcePopUp: false,
        PopUpEnd: true,
        RewardEnd: false,
        StudyEnd: false,
        RedDot: false,
        Reward: 0,
        Target: 0
      },
      UpiActivityShow: false,
      showUpiGiftReward: false,
      showBindMobileAlert: false
    }
  },
  components: {
    Loadmore,
    // DWCarousel,
    Setup,
    UpiGiftReward,
    TeachingPop,
    UpiActivity,
    UpiHelpPop,
    VersionUpdatePop,
    WithdrawalRule,
    WaitModal,
    GatewayError,
    TopBack,
    ConfirmWin,
    ConfirmAlert,
    Alert2,
    UpiInfoPop,
    BankCardInfoPop,
    BankTransferInfoPop,
    howToUseUSDTPop,
    splitWithdrawConfirmPop
  },
  computed: {
    getWindowHeight () {
      let height = window.innerHeight
      if (height > 740) {
        return 2
      } else {
        return 1
      }
    },
    tabCase () {
      return (item) => {
        return this.$route.name.startsWith(item.key) ? item.label.toUpperCase() : item.label
      }
    },
    judgeRow () {
      return (items) => {
        return items.some(item => this.fetchRange(item, 'deposit'))
      }
    },
    fetchRange () {
      return (amount, type) => {
        switch (type) {
          case 'deposit':
            // START: 2021-08-23 C007 根据当前选择的网关展示对应的可充值列表
            if (this.selectedGateway) {
              // 2021-11-25 CHP 24小时充值送只能进行 100、500、1000 三种数额
              return amount >= this.selectedGateway.DepositMinAmount && amount <= this.selectedGateway.DepositMaxAmount
            } else {
              return true
            }
          // END: 2021-08-23 C007
          case 'withdraw':
            return amount >= this.withdrawRange.Min && amount <= this.withdrawRange.Max
        }
      }
    }
  },
  watch: {
    selectedGateway (val) {
      if (val && val.DepositDiscountRange && this.minDepositIndex) {
        val.DepositDiscountRange = this.processDiscount(val.DepositDiscountRange)
      }
    },
    '$store.state.locale': function (val) {
      this.lang = val
      this.topTitle = this.$t('lang.menu.' + this.$route.name)
      this.tabList = [
        {
          label: this.$t('lang.menu.Account'),
          key: 'Account'
        },
        {
          label: this.$t('lang.account.deposit'),
          key: 'Deposit'
        },
        {
          label: this.$t('lang.account.withdraw'),
          key: 'Withdraw'
        }
      ]
      this.discounts.forEach((discount) => {
        if (discount.type === 'wheel_deposit' || discount.type === 'deposit630_discount' || discount.type === 'inner_discount' || discount.type === '7day_gift_version_c') {
          discount.onlyName = this.$t('lang.account.' + discount.type)
          const timeShow = this.getRemainingTime(discount.date)
          discount.name = discount.onlyName + ' ' + discount.rate + '% (' + timeShow + ')'
        } else {
          discount.name = this.$t('lang.account.' + discount.type)
        }
      })
      if (this.discountName) {
        if (this.discountType === 'wheel_deposit' || this.discountType === 'deposit630_discount' || this.discountType === 'inner_discount' || this.discountType === '7day_gift_version_c') {
          this.discountName = this.discounts.filter((e) => {
            return e.guid && e.guid === this.discountGuid
          })[0].name
        } else {
          this.discountName = this.$t('lang.account.' + this.discountType)
        }
      }
    },
    'withdrawSetup': function (n, o) {
      let accountPage = document.getElementById('accountPage')
      if (n) {
        accountPage.scrollTop = 0
      }
    },
    '$route' (to, from) {
      this.splitWithdrawOptionItemActive = 1
      const key = to.name
      const tab = this.tabList.find(item => item.key === key)
      if (tab.key === 'Account') {
        this.topTitle = this.$t('lang.menu.Account')
      } else {
        this.topTitle = tab.label
      }
      if (!localStorage.getItem('userInfo')) {
        this.$router.push('/Login')
        // this.$store.commit('setLoginPopShow', true)
      } else {
        if (to.name === 'Deposit') {
          this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
          this.getDepositActivity()
          if (from.name !== 'Deposit') {
            this.getUpiUserData()
          }
        } else if (to.name === 'Withdraw') {
          this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
          this.fetchVerifyInfo()
        }
      }
      if (to.name === from.name) { // 临时处理跳转入upi tab返回不成功
        this.$router.push('/Home')
      }
    }
  },
  created () {
    if (!localStorage.getItem('userInfo')) {
      this.$router.push('/Login')
      // this.$store.commit('setLoginPopShow', true)
    } else {
      if (this.$route.name === 'Deposit') {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
        this.getDepositActivity()
      } else if (this.$route.name === 'Withdraw') {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
        this.fetchVerifyInfo()
      }
    }
  },
  mounted () {
    // this.$store.state.confirmWinShow = true // 弹出confirm窗
    if (!localStorage.getItem('userInfo')) {
      return
    }
    // this.selectDepositTab('UPI')//E-Wallet
    this.getRate()
    this.getWarning()
    if (!localStorage.getItem('waitShowDate')) {
      this.waitPopShow = true
    } else {
      this.waitPopShow = !LogUtils.isSameDay(Date.now(), localStorage.getItem('waitShowDate') * 1)
    }
    this.showTipsContentByDelay() // 充值tips关闭按钮延迟显示
    localStorage.setItem('currencyIcon', fetchCurrency[this.userInfo.CurrencyName])

    this.fetchAccount(false)

    if (this.$route.name === 'Withdraw') {
      // 2022-02-17 CHP 根据国家版本确定提款范围
    } else if (this.$route.name === 'Deposit') {
      // 获取Upi教学活动配置
      this.getUpiUserData()
    }
    this.mounted = true
    if (!this.discountTimeInterval) {
      this.discountTimeInterval = setInterval(() => {
        this.updateDiscountDate()
      }, 60000)
    }
  },
  updated () {
  },
  methods: {
    ...mapMutations({
      setCurrentRoute: 'setCurrentRoute',
      setUserVerifyInfo: 'setUserVerifyInfo',
      setUserBankList: 'setUserBankList'
    }),
    computedTotal () {
      return this.computedAmount() + this.depositCashBonus.cash
    },
    computedAmount (amount, rate) {
      return Math.ceil(this.depositCashBonus.amount * this.rates)
    },
    closeHowToUseUSDTPop () {
      this.howToUseUSDTPopShow = false
    },
    getUSDTTip (val) {
      return val.replace(/\\n|\r?\n/g, '</p><p>').replace('{rate}', this.rates || '-')
    },
    getRate () {
      request('get', '/innovation/payments/get/usdt2inr/rate').then(res => {
        if (res && res.Rate) {
          this.rates = res.Rate
        }
      })
    },
    handleOpenChat () {
      LogUtils.saveUserEvent('openChatFromDepositMcPay', this.userInfo.UserId)
      if (this.userInfo && this.userInfo.UserShowId) {
        window.LiveChatWidget.call('set_customer_name', this.userInfo.UserShowId)
      } else {
        window.LiveChatWidget.call('set_customer_name', ' ')
      }
      window.LiveChatWidget.call('maximize')
      this.McPayRemiderShow = false
    },
    closeSplitWithdrawConfirmPop () {
      this.splitWithdrawConfirmPopShow = false
    },
    setSplitWithdrawOptionItemActive (splitWithdrawOptionItemActive) {
      this.splitWithdrawOptionItemActive = splitWithdrawOptionItemActive
    },
    getSplitWithdrawAmount (withdrawAmount) {
      let splitNums = 0
      if (withdrawAmount && withdrawAmount >= this.SplitAmount) {
        splitNums = Math.ceil((withdrawAmount / this.SplitAmount))
        return withdrawAmount + ' / ' + splitNums
      } else {
        return withdrawAmount
      }
    },
    activeSplitWithdrawOption (val) {
      this.splitWithdrawOptionItemActive = val
    },
    formatterRuleContent (content) {
      return content.replace(/\\n|\r?\n/g, '</p><p>')
    },
    commitUPIInfo (v) {
      this.VpaAddress = v
      this.doDeposit()
    },
    goHistory () {
      this.$router.push({
        path: '/History',
        query: {
          type: 'w'
        }
      })
    },
    onModalClose () {
      this.leaveConfirmed = false // 用户关闭弹窗时重置确认状态
      this.$store.commit('setWaitShow', false)
    },
    proceedToNextRoute () {
      this.leaveConfirmed = true // 用户确认离开
      this.$store.commit('setWaitShow', false)
      this.$router.push('/' + this.leaveToRoute)
    },
    activeEventOfNav (GatewayType) {
      const activeList = this.gatewayList.filter((item) => {
        return this.DepositGatewayActivity.includes(item.Name) && GatewayType === item.GatewayType2
      })
      return activeList && activeList.length > 0
    },
    openHowToUSDTPop () {
      this.howToUseUSDTPopShow = true
    },
    how2UseUpi () {
      this.showUpiHelpPop = true
    },
    refreshBalance () {
      LogUtils.logout9w()
      this.fetchAccount(false)
      this.balance = 0
      this.doFreshBalance()
    },
    refreshWithDraw () {
      LogUtils.logout9w()
      this.fetchAccount(false)
      this.withdrawBalance = 0
      this.doFreshWithdraw()
    },
    doFresh () {
      const totalBalance = this.accountInfo.Cash + this.accountInfo.Gift + this.accountInfo.WithdrawableCash
      if (this.balance < totalBalance) {
        this.balance += parseFloat((totalBalance / 10).toFixed(2))
        setTimeout(() => {
          this.doFresh()
        }, 80)
      } else {
        this.balance = totalBalance
      }
    },
    doFreshBalance () {
      const total = this.accountInfo.Cash + this.accountInfo.Gift + this.accountInfo.WithdrawableCash + this.accountInfo.TransferAmount
      if (this.balance < total) {
        this.balance += parseFloat((total / 10).toFixed(2))
        setTimeout(() => {
          this.doFreshBalance()
        }, 80)
      } else {
        this.balance = total
      }
    },
    doFreshWithdraw () {
      const total = this.accountInfo.WithdrawableCash
      if (this.withdrawBalance < total) {
        this.withdrawBalance += parseFloat((total / 10).toFixed(2))
        setTimeout(() => {
          this.doFreshWithdraw()
        }, 80)
      } else {
        this.withdrawBalance = total
      }
    },
    /****
     *
     * @param label
     * 2021-07-31 CHP 点击当前Label时，刷新当前页
     */
    selectTab (key) {
      if (key === this.$route.name) {
        return false
      }
      this.setCurrentRoute(key)
      this.$router.push('/' + key)
      if (this.$route.name === 'Deposit' && this.warningShow === true) {
        this.warningShow = false
        setTimeout(() => {
          this.warningShow = true
        })
      }
    },
    getDepositActivity () { // 2023-04-13 hp 更新周六会员日充值赠送页面效果
      const userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}
      const url = '/innovation/account/get/deposit/activity'
      const data = {
        userId: userInfo.UserId || ''
      }
      request('post', url, data, true).then(res => {
        this.activity = res
        this.fetchGateWay()
      })
    },
    fetchAmount (value, type, index, indx) {
      switch (type) {
        case 'deposit':
          this.depositAmount = value
          this.computeDepositTotal(value, index, indx)
          break
        case 'withdraw':
          this.withdrawAmount = value
          this.splitWithdrawOptionItemActive = 1
          break
      }
    },
    computeDepositTotal (value, index, indx) {
      if (this.selectedGateway.DepositDiscountRange && this.selectedGateway.DepositDiscountRange[index] && this.selectedGateway.DepositDiscountRange[index][indx]) {
        this.depositCashBonus.amount = value

        if (this.$store.state.userFirstDeposit === true || !this.showPercent) {
          this.depositCashBonus.cash = this.selectedGateway.DepositDiscountRange[index][indx] * 1
        } else {
          this.depositCashBonus.cash = value * this.selectedGateway.DepositDiscountRange[index][indx] * 0.01
        }

        this.cashUpPerc = this.selectedGateway.DepositDiscountRange[index][indx]
        this.depositCashBonus.total = this.depositCashBonus.amount + this.depositCashBonus.cash // 移除bonus by HHY 2022-10-29
      } else {
        this.depositCashBonus.amount = value
        this.depositCashBonus.cash = 0
        this.cashUpPerc = 0
        this.depositCashBonus.total = this.depositCashBonus.amount + this.depositCashBonus.cash
      }
    },
    fetchTransaction (item) {
      this.selectedGateway = item
      this.depositAmount = item.DepositDefultAmount
      this.locateInDepositRangeAndComputeDepositTotal()
    },
    updateDiscountDate () {
      // 建立一个数组放入过期充赠券的Guid
      let expireGuid = []
      this.discounts.forEach((discount, index) => {
        let timeShow = ''
        if (discount.date) {
          timeShow = this.getRemainingTime(discount.date)
          this.discounts[index].name = discount.onlyName + ' ' + discount.rate + '% (' + timeShow + ')'
          if (timeShow === 'expire') {
            expireGuid.push(discount.guid)
          }
        }
        if (this.discountType === 'deposit630_discount' || this.discountType === 'wheel_deposit' || this.discountType === 'inner_discount' || this.discountType === '7day_gift_version_c') {
          this.discountName = this.discounts.filter((e) => {
            return e.guid === this.discountGuid
          })[0].name
        }
      })
      // 刷新掉已经过期的充赠券
      if (expireGuid && expireGuid.length > 0) {
        this.discounts = this.discounts.filter((e) => {
          return !expireGuid.includes(e.guid)
        })
      }
      if (expireGuid.includes(this.discountGuid)) {
        this.chooseDiscountType(this.discounts[0])
      }
    },
    getRemainingTime (date) {
      let date2 = new Date(date)
      let date1 = new Date()
      // 计算时间差（以毫秒为单位）
      let timeDiff = date2.getTime() - date1.getTime()

      // 如果时间差小于一分钟，返回 "0 天 0 小时 0 分钟"
      if (timeDiff < 60000 && timeDiff > 0) {
        return '00d 00:00'
      }
      if (timeDiff <= 0) {
        return 'expire'
      }

      // 将时间差转换为天、小时、分钟
      let days = Math.floor(timeDiff / (1000 * 60 * 60 * 24))
      let hours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      let minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60))

      // 构建输出字符串
      let result = `${this.formatTwoDigits(days)}d ${this.formatTwoDigits(hours)}:${this.formatTwoDigits(minutes)}`
      return result
    },
    // 辅助函数：确保输出两位数格式
    formatTwoDigits (num) {
      return num.toString().padStart(2, '0')
    },
    fetchAccount (effect) {
      if (this.userInfo) {
        const url = '/innovation/account/getuseraccount'
        const data = {
          userId: this.userInfo.UserId
        }
        request('post', url, data, true).then(res => {
          let index = res.InviteLink.indexOf('/Share')
          if (index === -1) {
            index = res.InviteLink.toLowerCase().indexOf('/share')
          }

          this.accountInfo = res
          if (effect) {
            this.balance = 0
            this.doFresh()
          } else {
            this.balance = this.accountInfo.Cash + this.accountInfo.Gift + this.accountInfo.WithdrawableCash + this.accountInfo.TransferAmount
            this.withdrawBalance = this.accountInfo.WithdrawableCash
          }
          this.cw = this.accountInfo.Cash + this.accountInfo.WithdrawableCash
          this.fetchAmount(this.withdrawAmountList[0][1], 'withdraw')
        }).catch(err => {
          console.log(err)
        })
      }
    },
    showWithdrawalRules () {
      if (this.feeFreeStatus === 0) {
        this.popMessage = this.$t('lang.account.withdrawalRuleList')
      } else if (this.feeFreeStatus === 1) {
        this.popMessage = this.$t('lang.account.withdrawalRuleListB')
      } else if (this.feeFreeStatus === 2) {
        this.popMessage = this.$t('lang.account.withdrawalRuleListC')
      } else {
        this.popMessage = this.$t('lang.account.withdrawalRuleListD')
      }
      this.showPopMessage = true
      this.popType = 2
    },
    closeDepositMsgPop () {
      this.showPopMessage = false
      if (this.popType === 0) {
        this.doDeposit()
      }
    },
    closeDepositMsgPop2 () {
      this.showPopMessage2 = false
    },
    handleDeposit () {
      if (!this.agreeCheck) {
        Toast(this.$t('lang.account.check'))
        return
      }
      if (!this.depositAmount) {
        Toast(this.$t('lang.account.selectDepositAmount'))
        return
      }

      if (!this.selectedGateway) {
        Toast(this.$t('lang.account.selectUPIChannel'))
        return
      }

      if (!this.userInfo) {
        Toast(this.$t('lang.account.needLogin'))
        return
      }
      LogUtils.saveUserEvent('depositSubmit', this.userInfo.UserId)
      let delay = 0
      if (localStorage.getItem('cid') && this.$store.state.adCid.includes(localStorage.getItem('cid'))) {
        adListener('DepositSubmit')
        if (!localStorage.getItem('DepositPerson')) {
          localStorage.setItem('DepositPerson', '1')
          adListener('DepositPerson')
        }
        delay = 500
      }
      setTimeout(() => {
        if (this.selectedGateway.RuleText) {
          this.popMessage2 = this.selectedGateway.RuleText
          this.showPopMessage2 = true
          this.popType = 0
        } else {
          if (this.selectedGateway && this.selectedGateway.GatewayMode === 'seamless') {
            this.UpiInfoPopShow = true
          } else {
            if (this.depositNav.toLowerCase() === 'usdt') {
              let t = localStorage.getItem('usdtTimes')
              t = t ? parseInt(t) : 0
              if (t < 3) {
                this.usdtGuide = true
                t = t + 1
                localStorage.setItem('usdtTimes', t)
                return
              }
            }
            this.doDeposit()
          }
          // else {
          //     this.BankTransferInfoPopShow = true
          //   }
          // this.doDeposit()
        }
      }, delay)
    },
    doNewOrder () {
      LogUtils.saveUserEvent('DepositMonitoring2', this.userInfo.UserId)
      this.gatewayErrorShow = false
      const url = '/innovation/payments/deposit2'
      request('post', url, this.retryObject).then(res => {
        // 2021-08-13 C007 增加处理Depsoit网关处于维护状态的逻辑
        if (res.Code > 0) {
          fbListener('Front-Deposit')
          // start 2021-07-30 C007 跳转第三方前显示动画
          if (document.getElementById('loading').innerHTML.trim() === '') {
            var imageHtml = '<div><img src="static/images/loading.gif" alt=""></div>'
            document.getElementById('loading').innerHTML = imageHtml
          }
          document.getElementById('loading').style.display = 'block'
          // end 2021-07-30 C007

          if (res.Code === 1 && res.Url) {
            if (res.Operation === 'jump') {
              this.$store.commit('setDepositListening', true)
              location.href = res.Url
            } else if (res.Operation === 'QRCode') {
              this.QRCodeShow = true
              this.QRCode = res.Url
            } else {
            }
          } else {
            this.formData = res.FormField
            this.GladPayUrl = res.Url
            this.$nextTick(() => {
              this.$refs.form.submit()
            })
          }
        } else {
          switch (res.Code) {
            case -1:
              this.retryObject = res.RequestParams
              this.retryObject.RetryMsg = res.Message
              this.retryObject.IsRetry = true
              this.gatewayErrorShow = true
              LogUtils.saveUserEvent('DepositMonitoring1', this.userInfo.UserId)
              break
            case -2:
              this.showUpgradePop = true
              break
          }
        }
        document.getElementById('loading').style.display = 'none'
      }).catch(err => {
        console.log(err)
        Toast(this.$t('lang.common.errorPrompt'))
      })
    },
    doDeposit () {
      this.usdtGuide = false
      if (this.selectedGateway.Name.toLowerCase() === 'payru') {
        const payru = localStorage.getItem('payru') // 记录弹出状况
        if (!payru) { // 判断是否弹出过没弹出过直接弹出
          const param1 = {
            date: Date.now(),
            count: 1,
            total: 1
          }
          localStorage.setItem('payru', JSON.stringify(param1))
          this.payRuAlertShow = true
        } else {
          const param2 = JSON.parse(payru)
          if (param2.total >= 9) { // 弹出9次永久不弹出了
            this.deposit2()
            return
          }
          if (LogUtils.isSameDay(Date.now(), param2.date)) { // 弹出过且是今天弹出
            if (param2.count < 3) { // 次数小于三次
              const param3 = {
                date: Date.now(),
                count: (1 + param2.count) * 1,
                total: (1 + param2.total) * 1
              }
              localStorage.setItem('payru', JSON.stringify(param3))
              this.payRuAlertShow = true
            } else { // 次数超过3次了不弹出了
              this.deposit2()
            }
          } else { // 今天没弹过直接弹
            const param4 = {
              date: Date.now(),
              count: 1,
              total: (1 + param2.total) * 1
            }
            localStorage.setItem('payru', JSON.stringify(param4))
            this.payRuAlertShow = true
          }
        }
        // eslint-disable-next-line no-constant-condition,no-self-compare
      } else if (this.selectedGateway.Name.toLowerCase().indexOf('mcpay') > -1) {
        const payru = localStorage.getItem('payru') // 记录弹出状况
        if (!payru) { // 判断是否弹出过没弹出过直接弹出
          const param1 = {
            date: Date.now(),
            count: 1,
            total: 1
          }
          localStorage.setItem('payru', JSON.stringify(param1))
          this.payRuAlertShow = true
        } else {
          const param2 = JSON.parse(payru)
          if (param2.total >= 9) { // 弹出9次永久不弹出了
            this.mcPayCheckTimeState()
            return
          }
          if (LogUtils.isSameDay(Date.now(), param2.date)) { // 弹出过且是今天弹出
            if (param2.count < 3) { // 次数小于三次
              const param3 = {
                date: Date.now(),
                count: (1 + param2.count) * 1,
                total: (1 + param2.total) * 1
              }
              localStorage.setItem('payru', JSON.stringify(param3))
              this.payRuAlertShow = true
            } else { // 次数超过3次了不弹出了
              this.mcPayCheckTimeState()
            }
          } else { // 今天没弹过直接弹
            const param4 = {
              date: Date.now(),
              count: 1,
              total: (1 + param2.total) * 1
            }
            localStorage.setItem('payru', JSON.stringify(param4))
            this.payRuAlertShow = true
          }
        }
      } else {
        this.deposit2()
      }
    },
    mcPayCheckTimeState () {
      request('post', '/innovation/payments/mcpay/is/processing', {
        userId: this.userInfo.UserId
      }).then(res => {
        console.log(res)
        if (res) {
          this.checkIsMcPay()
        } else {
          this.deposit2()
        }
      })
    },
    closePayRu () {
      this.payRuAlertShow = false
      if (this.selectedGateway.Name.toLowerCase().indexOf('mcpay') > -1) {
        this.mcPayCheckTimeState()
      } else {
        this.deposit2()
      }
    },
    closePayFutureMsg () {
      this.payFutureMsgShow = false
    },
    checkIsMcPay () {
      LogUtils.saveUserEvent('openReminderPopFromDepositMcPay', this.userInfo.UserId)
      this.McPayRemiderShow = true
    },
    goNewOrder () {
      LogUtils.saveUserEvent('clickNewOrderFromDepositMcPay', this.userInfo.UserId)
      this.McPayRemiderShow = false
      this.deposit2()
    },
    deposit2 () {
      const url = '/innovation/payments/deposit2'
      const data = {
        userId: this.userInfo.UserId,
        amount: this.depositAmount,
        hasBonus: this.bonusCheck,
        apkVersion: localStorage.getItem('apkV') ? localStorage.getItem('apkV') : '1.0.0',
        cid: localStorage.getItem('cid'),
        gateway: this.selectedGateway.Name,
        internation: this.$store.state.internation, // 2021-11-25 CHP 增加
        cashUpPercentage: this.cashUpPerc, // 2022-08-23 HHY 增加 // 2022-11-11 HHY 暂时没用到后台（后台未接收），目前只是前端显示用
        forCopyVisible: false,
        discountType: this.discountType,
        GiftUuid: this.discountGuid,
        IsRetry: false,
        VpaAddress: this.VpaAddress
      }
      request('post', url, data).then(res => {
        // 2021-08-13 C007 增加处理Depsoit网关处于维护状态的逻辑
        if (res.Code > 0) {
          LogUtils.logout9w()
          if (res.Operation === 'SelfHtml') {
            let depositInfo = {
              amount: this.depositAmount,
              Url: res.Url
            }
            if (depositInfo) {
              this.$router.push({
                query: {
                  depositInfo: JSON.stringify(depositInfo)
                },
                path: '/depositChannelsPage'
              })
            }
          } else {
            if (res.Url === 'seamless') {
              this.payFutureMsgShow = true
              return
            }
            // start 2021-07-30 C007 跳转第三方前显示动画
            if (document.getElementById('loading').innerHTML.trim() === '') {
              var imageHtml = '<div><img src="static/images/loading.gif" alt=""></div>'
              document.getElementById('loading').innerHTML = imageHtml
            }
            document.getElementById('loading').style.display = 'block'
            // end 2021-07-30 C007

            if (res.Code === 1 && res.Url) {
              // this.$store.commit('setDepositListening', true)
              // location.href = res.Url
              if (res.Operation === 'jump') {
                this.$store.commit('setDepositListening', true)
                location.href = res.Url
              } else if (res.Operation === 'QRCode') {
                this.QRCodeShow = true
                this.QRCode = res.Url
              } else {
              }
            } else {
              this.formData = res.FormField
              this.GladPayUrl = res.Url
              this.$nextTick(() => {
                this.$refs.form.submit()
              })
            }
          }
        } else {
          switch (res.Code) {
            case -1:
              this.retryObject = res.RequestParams
              this.retryObject.RetryMsg = res.Message
              this.retryObject.IsRetry = true
              this.gatewayErrorShow = true
              LogUtils.saveUserEvent('DepositMonitoring1', this.userInfo.UserId)
              break
            case -2:
              this.showUpgradePop = true
              break
          }
        }
        document.getElementById('loading').style.display = 'none'
      }).catch(err => {
        console.log(err)
        Toast(this.$t('lang.common.errorPrompt'))
      })
    },
    isMondayOrWeekend () {
      // 获取当前星期（0=周日, 1=周一 ... 6=周六）
      const day = new Date().getDay()
      // 判断是否为 周一(1)、周六(6)、周日(0)
      if (day === 1 || day === 6 || day === 0) {
        this.handleWithdraw()
        // this.mondayOrWeekendPopShow = true
      } else {
        this.handleWithdraw()
      }
    },
    handleWithdraw () {
      this.mondayOrWeekendPopShow = false
      if (this.accountInfo.WithdrawableCash < this.withdrawAmount) return Toast(this.$t('lang.account.notEnough'))
      if (this.withdrawAmount === 0) return Toast(this.$t('lang.account.selectWithdrawAmount'))
      this.withdrawSetup = 'account'
      this.doWithdraw(true)
      return
      // eslint-disable-next-line no-unreachable
      if (!this.withdrawAmount) {
        return Toast(this.$t('lang.account.chooseWithdrawAmount'))
      }
      if (this.userInfo) {
        if (!this.userInfo.Mobile) {
          request('post', '/innovation/account/getuserinfo', {
            userId: this.userInfo.UserId,
            isEditPage: false
          }).then(res => {
            if (res.Mobile) {
              this.userInfo.Mobile = res.Mobile
              localStorage.setItem('userInfo', JSON.stringify(this.userInfo))
            } else {
              this.showBindMobileAlert = true
            }
          })
          // eslint-disable-next-line no-unreachable
        } else {
          this.doWithdraw()
        }
      }
    },
    openDeatilShow (detailContent) {
      if (this.lang === 'IN') {
        this.detailContent = detailContent.DetailIN
      } else {
        this.detailContent = detailContent.DetailEN
      }
      this.deatilShow = true
    },
    doWithdraw (noShowMessage) {
      //
      if (this.activeBankAccount && this.activeBankAccount.BankCardVerifyStatus > 0) {
        let url = 'innovation/payments/validatewithdrawnsendhint/kyc_verification_free'
        const data = {
          userId: this.userInfo.UserId,
          amount: this.withdrawAmount,
          BankAccountId: this.activeBankAccount.Id
        }
        request('post', url, data).then(res => {
          this.withdrawFee = res.Value
          let inner = 'lang.withdrawMsg.message' + res.Code

          if (res.Code === 7 || res.Code === 8) { // 2022-11-29 HHY 添加确认确认框
            if (res.Code === 8) {
              this.withdrawConfirmText = this.$t(inner).replace('{amount}', this.$t('lang.account.currencyType') + res.Value)
            } else {
              this.withdrawConfirmText = this.$t(inner)
            }
            if (noShowMessage) {
              return
            }
            this.withdrawSetup = ''
            // this.withdrawConfirmText = this.$t('lang.WithdrawalSuccessful.confirmWithDrawTip').replace('{account}', this.withdrawAmount)
            // this.$store.state.confirmWinShow = false // 弹出confirm窗
            if (this.withdrawAmount >= this.SplitThreshold && this.splitWithdrawOptionItemActive === 0) {
              this.splitWithdrawConfirmPopShow = true
            } else {
              this.confirmWithDraw()
            }
            // 确认提款
            // this.confirmWithDraw()
          } else {
            let msg = this.$t(inner)
            if (res.Code === 6) {
              msg = msg.replace('{amount}', res.Value)
            }
            Toast(msg)
          }
        }).catch(err => {
          if (err.status === 400) {
            let inner = 'lang.withdrawMsg.message' + err.data.Code
            let msg = this.$t(inner)
            if (err.data.Code === 6) {
              msg = msg.replace('{amount}', err.data.Value)
            }
            Toast(msg)
          }
        })
      } else {
        Toast(this.$t('lang.account.promptToSubmitBankAccount'))
      }
    },
    // 2022-11-29 HHY 点击confirm的确认按钮后执行
    confirmWithDraw () {
      const data = {
        userId: this.userInfo.UserId,
        amount: this.withdrawAmount,
        BankAccountId: this.activeBankAccount.Id,
        IsSplit: this.splitWithdrawOptionItemActive === 1
      }
      // const url = '/innovation/payments/withdraw2'
      const url = '/innovation/payments/withdraw2/kyc_verification_free'
      request('post', url, data).then(res => {
        let inner = 'lang.withdrawMsg.message' + res.Code
        let msg = this.$t(inner)
        if (res.Code === 6) {
          msg = msg.replace('{amount}', res.Value)
        }
        if (res.Code === 1) {
          LogUtils.logout9w()
        }
        Toast(msg)

        this.fetchAccount(false) // 2021-06-19 CHEN ADD refresh account
        // this.$router.push('/WithdrawalSuccessful')
        this.$router.push({
          path: '/WithdrawalSuccessful',
          query: {
            withdrawAmount: this.withdrawAmount
          }
        })
      }).catch(err => {
        if (err.status === 400) {
          let inner = 'lang.withdrawMsg.message' + err.data.Code
          let msg = this.$t(inner)
          if (err.data.Code === 6) {
            msg = msg.replace('{amount}', err.data.Value)
          }
          Toast(msg)
        }
      })
    },
    closeGatewayError () {
      LogUtils.saveUserEvent('DepositMonitoring3', this.userInfo.UserId)
      this.gatewayErrorShow = false
    },
    copy () {
      this.$refs.link.select()
      document.execCommand('copy')
      Toast(this.$t('lang.account.copySuccess'))
    },
    copyCode () {
      this.$refs.shareCode.select()
      document.execCommand('copy')
      Toast(this.$t('lang.account.copySuccess'))
    },
    checkFeeFreeStatus () {
      const url = '/innovation/payments/withdrawal/strategy'
      const data = {
        CampaignId: localStorage.getItem('cid'),
        userId: this.userInfo.UserId
      }
      request('post', url, data, true).then(res => {
        if (res && res === 'versionA') {
          this.feeFreeStatus = 0
        } else if (res && res === 'versionB') {
          this.feeFreeStatus = 1
        } else if (res && res === 'versionC') {
          this.feeFreeStatus = 2
        } else {
          this.feeFreeStatus = 3
        }
      }).catch(err => {
        console.log(err)
      })
    },
    putRangeTogether (rangeArr, withdrawAmountList) {
      const allElements = [
        ...withdrawAmountList.flat(),
        ...rangeArr
      ]
      // 转数字后再去重
      const uniqueSorted = [...new Set(
        allElements.map(Number)
      )].sort((a, b) => a - b)
      const grouped = []
      for (let i = 0; i < uniqueSorted.length; i += 3) {
        grouped.push(uniqueSorted.slice(i, i + 3))
      }
      return grouped
    },
    fetchVerifyInfo () {
      const url = '/innovation/account/getuserverifyinfo'
      const data = {
        userId: this.userInfo.UserId
      }
      request('post', url, data, true).then(res => {
        // withdrawAmountList 后台提供
        const url2 = '/innovation/payments/withdrawal/config'
        const data2 = {}
        request('get', url2, data2, true).then(result => {
          if (result.SplitConfig) {
            if (!result.SplitConfig.SplitIsOpen) {
              this.SplitAmount = 100000000
              this.SplitThreshold = 100000000
            } else {
              this.SplitAmount = result.SplitConfig.SplitAmount
              this.SplitThreshold = result.SplitConfig.SplitThreshold
            }
          }
          if (res.MinWithdraw) {
            this.withdrawAmountList = this.putRangeTogether(res.MinWithdraw.split(','), result.WithdrawRange)
          } else {
            this.withdrawAmountList = result.WithdrawRange
          }
          this.fetchAmount(this.withdrawAmountList[0][1], 'withdraw')
          this.setUserVerifyInfo(res.UserVerifyInfo)
          this.setUserBankList(res.BankAccountList)
          const filterList = res.BankAccountList.filter((e) => {
            return e.IsLastUsed === true
          })
          if (filterList.length > 0) {
            this.activeCardId = filterList[0].Id
          }
          if (this.activeCardId === -1 && this.$store.state.bankList && this.$store.state.bankList.length > 0) {
            this.activeCardId = this.$store.state.bankList[0].Id
          }
          this.checkFeeFreeStatus()
          this.chooseCard(this.activeCardId)
        }).catch(e => {
          console.log(e)
        })
      }).catch(err => {
        console.log(err)
      })
    },
    chooseCard (id) {
      let bankList = this.$store.state.bankList
      bankList.forEach((e, i) => {
        e.Index = i
        if (e.Id === id) {
          e.IsLastUsed = true
          this.activeBankAccount = e
        } else {
          e.IsLastUsed = false
        }
      })
      this.setUserBankList(bankList)
    },
    /***
     * 获取支付网关
     * 2021-07-31 C007 创建
     * */
    fetchGateWay () {
      this.discounts = []
      // 没有高优先级充值的情况下,先处理充赠券
      if (!this.activity.FirstDeposit && !this.activity.TwiceDeposit && !this.activity.CallbackDeposit && this.activity.Discounts) {
        this.activity.Discounts.forEach((discount) => {
          const guid = discount.GiftUuid
          const type = discount.GiftType
          const onlyName = this.$t('lang.account.' + type)
          const date = discount.DueDate + ':00'
          const rate = discount.Discount
          const timeShow = this.getRemainingTime(date)
          const name = onlyName + ' ' + rate + '% (' + timeShow + ')'
          if (timeShow !== 'expire') {
            this.discounts.push({type: type, name: name, onlyName: onlyName, guid: guid, date: date, rate: rate})
          }
        })
      }
      // 首充/二充/回归 使用后台返回的discountType 优先级第一
      if (this.activity.FirstDeposit || this.activity.TwiceDeposit || this.activity.ThirdDeposit || this.activity.CallbackDeposit) {
        this.discountType = this.activity.DepositType
        this.discountName = this.$t('lang.account.' + this.discountType)
        this.discounts.unshift({type: this.discountType, name: this.discountName})
      } else if (this.$route.query.param === 'limitTime' || this.$route.query.guid || this.activity.MembersDayDeposit || this.activity.SundayDeposit) {
        if (this.activity.MembersDayDeposit || this.activity.SundayDeposit) { // 会员日
          this.discountType = this.activity.DepositType
          this.discountName = this.$t('lang.account.' + this.discountType)
          this.discounts.unshift({type: this.discountType, name: this.discountName})
        } else { // 没有会员日的情况下,又从天降福利或者充赠券入口进入用户可以选择使用优惠
          this.discountType = 'normal_deposit'
          this.discountName = this.$t('lang.account.' + this.discountType)
          this.discounts.push({type: this.discountType, name: this.discountName})
        }
        if (this.$route.query.param === 'limitTime') { // 天降福利入口进入
          this.discountType = 'welfare_deposit'
          this.discountName = this.$t('lang.account.' + this.discountType)
        }
        if (this.$route.query.guid) { // 充赠券入口进入
          this.discountGuid = this.$route.query.guid
          this.discountType = 'wheel_deposit'
          this.discountName = this.discounts.filter((e) => {
            return e.guid === this.discountGuid
          })[0].name
        }
      } else { // 平民优惠
        this.discounts.push({type: 'normal_deposit', name: this.$t('lang.account.normal_deposit')})
        if (!this.discounts || this.discounts.length === 0) {
          this.discountType = 'normal_deposit'
          this.discountName = this.$t('lang.account.' + this.discountType)
        } else {
          this.discountType = this.discounts[0].type
          this.discountName = this.discounts[0].name
          this.discountGuid = this.discounts[0].guid
        }
      }
      // 有天降福利资格
      if (this.activity.WelfareDeposit && !this.activity.FirstDeposit && !this.activity.TwiceDeposit && !this.activity.CallbackDeposit) {
        // 先放入天降福利到下拉列表
        this.discounts.unshift({type: 'welfare_deposit', name: this.$t('lang.account.welfare_deposit')})
        // 如果不是会员日优惠并且不是从充赠券入口进入，直接选中天降福利
        if (!this.activity.MembersDayDeposit && !this.activity.SundayDeposit && !this.$route.query.guid) { // 选中天降福利
          this.discountType = 'welfare_deposit'
          this.discountName = this.$t('lang.account.' + this.discountType)
        }
      }
      this.freshNav = true
      this.getGateWay2()
    },
    getWarning () {
      const url = '/innovation/account/warning'
      request('post', url, {}, true).then(res => {
        this.WarningEN = res.WarningEN
        this.WarningIN = res.WarningIN
        this.warningShow = res.WarningSwitch
        this.WithdrawableWarningEN = res.WithdrawableWarningEN
        this.WithdrawableWarningIN = res.WithdrawableWarningIN
        this.WithdrawwarningShow = res.WithdrawableWarningSwitch
      })
    },
    getGateWay2 () {
      const url = '/innovation/payments/getavailabledepositgateway2'
      const data = {
        userId: this.userInfo.UserId,
        internation: this.$store.state.internation,
        deposittype: this.discountType,
        giftuuid: this.discountGuid
      }
      request('post', url, data).then(res => {
        if (res.Code > 0) {
          if (res.DepositGatewayActivity) {
            this.DepositGatewayActivity = res.DepositGatewayActivity.split(',')
          }
          if (res.MinDeposit && res.MinDepositCids) {
            this.minDeposit = res.MinDeposit
            this.minDepositCids = res.MinDepositCids
          }
          this.gatewayList = res.GatewayList
          var counter = 0
          for (var index in this.gatewayList) { // 给每个gateway增加一个序号字段 by HHY 20220611
            counter++
            const gateway = this.gatewayList[index]
            gateway['No'] = counter
          }
          this.gatewayTypes = res.GatewayTypes // by HHY 20220609
          if (this.gatewayTypes.length > 0) {
            if (this.freshNav) {
              this.depositNav = this.gatewayTypes[0].GatewayType
            }
            if (this.isFromPromotionUpiGuide) {
              this.selectDepositTab('UPI')
              this.gatewayList.forEach(item => {
                if (item.Name === 'UPPay') {
                  this.fetchTransaction(item)
                }
              })
            } else if (res.DefaultType) {
              if (this.freshNav) {
                this.depositNav = res.DefaultType
              }
              this.selectDepositTab(this.depositNav)
            } else {
              this.selectDepositTab(this.depositNav)
            }
          }
        } else {
          Toast(res.Message)
        }
      }).catch(err => {
        console.log(err)
        Toast(this.$t('lang.common.errorPrompt'))
      })
    },
    /***
     * 复制数字货币列表
     * 2021-08-29 WANGXJ 创建
     * */
    coinCopyAddress (coinAddress) {
      let copy = function (e) {
        e.preventDefault()
        let text = coinAddress
        if (e.clipboardData) {
          e.clipboardData.setData('text/plain', text)
        } else if (window.clipboardData) {
          window.clipboardData.setData('Text', text)
        }
      }
      window.addEventListener('copy', copy)
      document.execCommand('copy')
      window.removeEventListener('copy', copy)
    },
    /***
     * upi活动方法 start
     * */
    UpiIconClick () {
      LogUtils.saveUserEvent('UpiGuide_ClickIcon', this.userInfo.UserId)
      this.goToUpiTeaching()
    },
    UpiPopGoClick () {
      LogUtils.saveUserEvent('UpiGuide_PopGo', this.userInfo.UserId)
      this.goToUpiTeaching()
    },
    closeBindMobile () {
      this.showBindMobileAlert = false
    },
    gotoEdit () {
      this.$router.push('/' + 'Edit')
    },
    goToUpiTeaching () {
      if (this.UpiActivityShow === true) {
        this.UpiActivityShow = false
      }
      this.TeachingPopShow = true
    },
    closeUpiActivityShow () {
      this.UpiActivityShow = false
      LogUtils.saveUserEvent('UpiGuide_PopClose', this.userInfo.UserId)
    },
    closeUpiGiftReward () {
      if (this.teachingAlertMode === 1) {
        LogUtils.saveUserEvent('UpiGuide_RewardClose', this.userInfo.UserId)
      }
      this.showUpiGiftReward = false
    },
    UpiGiftRewardToDo () {
      this.showUpiGiftReward = false
      switch (this.teachingAlertMode) {
        case 1:
          LogUtils.saveUserEvent('UpiGuide_RewardClaim', this.userInfo.UserId)
          this.selectDepositTab('UPI')
          break
        case 2:
          const url = '/innovation/upi/study/collect_reward'
          const data = {
            userId: this.userInfo.UserId
          }
          request('post', url, data).then(res => {
            if (res > 0) {
              Toast(this.$t('lang.common.success'))
              this.fetchBalance()
              this.getUpiUserData()
            }
          })
          break
      }
    },
    closeTeaching () {
      this.TeachingPopShow = false
    },
    finishUpiStudy () {
      this.TeachingPopShow = false
      if (this.UpiUser.StudyEnd === false) {
        const data = {
          userId: this.userInfo.UserId
        }
        const url = 'innovation/upi/study/study_end'
        request('post', url, data, true).then(res => {
          if (res === true) {
            this.UpiUser.StudyEnd = true
            this.teachingAlertMode = 1
            this.showUpiGiftReward = true
          }
        })
      } else {
        if (this.UpiUser.RedDot === true) {
          this.teachingAlertMode = 2
          this.showUpiGiftReward = true
        } else if (this.UpiUser.RewardEnd === true) {
          this.teachingAlertMode = 3
          this.showUpiGiftReward = true
        } else {
          this.teachingAlertMode = 1
          this.showUpiGiftReward = true
        }
      }
    },
    finishUpiForcePop () {
      const url = '/innovation/upi/study/popup_end'
      const data = {
        userId: this.userInfo.UserId
      }
      request('post', url, data, true)
    },
    getUpiUserData () {
      const url = '/innovation/upi/study/get_data'
      this.userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : ''
      if (!this.userInfo) {
        return
      }
      const data = {
        userId: this.userInfo.UserId
      }
      request('post', url, data, true).then(res => {
        /*
        ForcePopUp 是否强弹
        PopUpEnd   弹出结束
        RedDot     是否有红点
        Reward     奖励金额
        RewardEnd  领取过奖励
        StudyEnd   学习过
        Target     充值目标金额，才能领奖
        */
        if (res !== 0) {
          this.UpiUser = res
          if (res.ForcePopUp === true) {
            this.UpiActivityShow = true
            this.finishUpiForcePop()
          }
        }
      })
    },
    /***
     * upi活动方法 end
     * */
    closeUpgrade () {
      this.showUpgradePop = false
    },
    closeUpiHelp () {
      this.showUpiHelpPop = false
    },
    selectDepositTab: function (item) { // 选择gatewaytype的tab时触发 by HHY 20220609
      this.depositNav = item
      this.selectGatewaysByType(item)
    },
    processArray (originalArray, minDeposit) {
      this.minDepositIndex = originalArray
        .flat() // 展平数组
        .findIndex(num => num >= minDeposit)
      // 1. 展平数组并过滤小于 minDeposit 的数字
      const flatArray = originalArray
        .flat() // 展平数组
        .filter(num => num >= minDeposit) // 移除小于 minDeposit 的数字

      // 2. 重新分组，每组 3 个元素
      const groupSize = originalArray[0].length ? originalArray[0].length : 3
      const result = []
      for (let i = 0; i < flatArray.length; i += groupSize) {
        result.push(flatArray.slice(i, i + groupSize))
      }

      return result
    },
    processDiscount (depositRange) {
      if (this.minDepositIndex) {
        // 1. 展平数组并过滤小于 minDeposit 的数字
        const flatArray = depositRange
          .flat() // 展平数组
          .filter((num, index) => index >= this.minDepositIndex)
        const groupSize = depositRange[0].length ? depositRange[0].length : 3
        const result = []
        for (let i = 0; i < flatArray.length; i += groupSize) {
          result.push(flatArray.slice(i, i + groupSize))
        }
        return result
      } else {
        return depositRange
      }
    },
    selectGatewaysByType: function (item) {
      this.gatewayListByType = []
      for (var index in this.gatewayList) {
        const gateway = this.gatewayList[index]
        if (gateway.GatewayType2 === item) {
          this.gatewayListByType.push(gateway)
        }
      }
      if (this.gatewayListByType.length > 0) {
        if (this.minDeposit && this.minDepositCids && localStorage.getItem('cid') && this.minDepositCids.includes(localStorage.getItem('cid'))) {
          try {
            const i = this.minDepositCids.indexOf(localStorage.getItem('cid'))
            if (i !== null && i !== undefined) {
              const minDeposit = this.minDeposit[i] * 1
              this.gatewayListByType.forEach((gatewayList) => {
                gatewayList.DepositRange = this.processArray(gatewayList.DepositRange, minDeposit)
                gatewayList.DepositDefultAmount = gatewayList.DepositDefultAmount < minDeposit ? gatewayList.DepositRange[0][0] : gatewayList.DepositDefultAmount
              })
            }
          } catch (e) {
            console.error(e)
          }
        }
        if (this.freshNav) {
          this.selectedGateway = this.gatewayListByType[0]
          this.depositAmount = this.selectedGateway.DepositDefultAmount
        } else {
          this.selectedGateway = this.gatewayListByType.filter((gateway) => {
            return this.selectedGateway.Id === gateway.Id
          })[0]
          if (!this.selectedGateway) {
            this.selectedGateway = this.gatewayListByType[0]
          }
          this.freshNav = true
        }
        this.locateInDepositRangeAndComputeDepositTotal()
      }
    },
    showTypeDrop () {
      this.typeDropShow = !this.typeDropShow
    },
    judgeActive (item) {
      if (this.discountType === item.type && this.discountName === item.name && this.discountType !== 'wheel_deposit' && this.discountType !== 'deposit630_discount' && this.discountType !== 'inner_discount' && this.discountType !== '7day_gift_version_c') {
        return true
      } else if (this.discountType === item.type && this.discountName === item.name && this.discountGuid === item.guid && (this.discountType === 'wheel_deposit' || this.discountType === 'deposit630_discount' || this.discountType === 'inner_discount' || this.discountType === '7day_gift_version_c')) {
        return true
      } else {
        return false
      }
    },
    chooseDiscountType (item) {
      if (this.judgeActive(item)) {
        this.typeDropShow = false
        return
      }
      this.discountName = item.name
      this.discountType = item.type
      if (this.discountType === 'deposit630_discount' || this.discountType === 'wheel_deposit' || this.discountType === 'inner_discount' || this.discountType === '7day_gift_version_c') {
        this.discountGuid = item.guid
      }
      this.freshNav = false
      this.getGateWay2()
      this.typeDropShow = false
    },
    closeDepositStep () {
      this.showDepositStep = false
    },
    locateInDepositRangeAndComputeDepositTotal () { // 寻找默认充值额度在所有可选充值额度中得索引位置
      var x = -1
      var y = -1
      for (let i = 0; i < this.selectedGateway.DepositRange.length; i++) {
        var range = this.selectedGateway.DepositRange[i]
        for (let j = 0; j < range.length; j++) {
          if (this.selectedGateway.DepositRange[i][j] === this.depositAmount) {
            x = i
            y = j
          }
        }
      }
      this.computeDepositTotal(this.depositAmount, x, y) // 根据索引位置，计算默认充值额度下，用户能得到的最后值（考虑返利、bonus等） by HHY 2022-08-16
    },
    showTipsContentByDelay () {
      setTimeout(() => {
        this.tipsDelayAwhile = true
        return null
      }, 8000)
    },
    changeDepositRangeBg (index) { // 2022-10-21 HHY 根据行变换充值优惠显示背景
      if (index === 0) {
        return 'discountRange'
      } else if (index === 1) {
        return 'discountRange2'
      } else if (index === 2) {
        return 'discountRange3'
      } else {
        return 'discountRange'
      }
    }
  },
  /****
   *
   * @param to
   * @param from
   * @param next
   * 2021-07-26 C007 Fix error: 用户未登录时，获取VerifyInfo出错
   */
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (from.query.key === 'UpiGuide' || to.query.key === 'UpiGuide') { // 2022-10-21 HHY 如果来自promotion页的UPI活动
        vm.isFromPromotionUpiGuide = true
        // fetchTransaction
      }
    })
  },
  /****
   * 离开页面时显示动画，在Main.js里进入页面时取消动画
   * 这个主要是为了解决从充值页面切换到支付网关之间的停顿
   * @param to
   * @param from
   * @param next
   */
  beforeRouteLeave (to, from, next) {
    this.isFromPromotionUpiGuide = false // 初始化
    this.isFirstDeposit = false
    if (this.userInfo && this.waitPopShow && !this.leaveConfirmed && from.name === 'Deposit' && to.name !== 'Deposit' && to.name !== 'depositChannelsPage') {
      this.leaveToRoute = to.name
      this.waitPopShow = false
      localStorage.setItem('waitShowDate', Date.now())
      this.$refs.waitModal.open()
      next(false) // 阻止路由跳转
    } else {
      next() // 允许路由跳转
    }
  },
  beforeDestroy () {
    if (this.discountTimeInterval) {
      clearInterval(this.discountTimeInterval)
    }
  }
}
</script>

<style lang="less" scoped>
.accountPage {
  position: fixed;
  width: 100vw;
  height: 100dvh;
  padding: 56px 0 70px 0; // 2022-03-27 CHP Fix tab被topbar遮挡
  overflow-x: hidden;
  overflow-y: auto;

  .tabList {
    position: relative;
    display: flex;
    text-align: center;
    justify-content: space-between;
    align-items: center;
    padding: 15px 5px 0 5px;

    .tab {
      padding: 0 5px 5px;
      font-size: 3.88vw;
      color: #FFFFFF;
      flex: 1;
    }

    .tabSelected {
      color: #F6D9AA;
      line-height: 21px;
      font-weight: 500;
      border-bottom: 2px solid #F6D9AA;
    }
  }

  @keyframes blink {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  .waringBox {
    display: flex;
    justify-content: center;
    height: max-content;

    .warning {
      margin-top: 2.7vw;
      font-weight: 400;
      letter-spacing: -0.01em;
      text-align: left;
      background: rgba(110, 10, 10, 0.41);
      animation: blink .6s linear 2;
      height: max-content;
      width: 100vw;
      color: rgba(245, 241, 241, 0.85);
      font-size: calc(14vw / 3.6);
      line-height: calc(16vw / 3.6);
      min-height: 7.777vw;
      padding: 1.38vw 5.55vw;
      overflow: hidden;
      overflow-y: auto;
    }
  }

  .tabContainer {
    margin-top: 4.16vw;
    height: max-content;
    padding: 0 4.44vw;
    z-index: 0;

    .text-line {
      display: flex;
      justify-content: space-between;
      align-items: center;
      line-height: 6vw;
      padding: 0 2vw 0 0.5vw;
      font-family: Inter;
      font-weight: 500;
      font-size: 3.888vw;
      text-transform: capitalize;

      .right-text {
        color: #E9E9E9;
      }
    }

    .money {
      position: relative;
      color: #FFFFFF;
      border: none;
      font-size: 30px;
      line-height: 32px;
      font-weight: bold;
      text-align: center;
      display: flex;
      justify-content: center;

      .spanHide {
        position: relative;
        margin-left: 36px;
        color: rgba(0, 0, 0, 0)
      }

      .spanShow {
        position: absolute;
        top: 0;
        color: #FFFFFF;
      }

      .refresh {
        margin: 1px 0 0 5px !important;
        border: none !important;
        width: max-content;
        height: 23px;
        padding: 0 !important;

        img {
          width: 16px;
          height: 23px;
        }
      }
    }

    .money2 {
      position: relative;
      margin-top: 5px;
      border: none;
      font-size: 23px;
      line-height: 32px;
      height: 32px;
      font-weight: bold;
      text-align: center;
      display: flex;
      justify-content: flex-start;

      .spanHide {
        position: relative;
        margin-left: 8px;
        color: rgba(0, 0, 0, 0)
      }

      .spanShow {
        position: absolute;
        top: 0;
        color: #DEBC86;
      }

      .refresh {
        border: none !important;
        width: max-content;
        height: 23px;
        padding: 0 !important;
        height: 32px;
        display: flex;
        align-items: center;

        img {
          width: auto;
          height: 23px;
        }
      }
    }

    .caption {
      font-size: 18px;
      line-height: 21px;
      color: #F6D9AA;
      margin-bottom: 10px;
      display: flex;
      justify-content: space-between;
    }

    .bonus-wagering {
      font-size: 14px;
      color: #FFFFFF;
      text-decoration: underline;
    }

    .tips {
      font-size: 12px;
      line-height: 14px;
      color: #686868;
      //margin-bottom: 10px;
      //margin-top: -10px;
    }

    .warnings {
      color: #F6D9AA;
      margin-bottom: 25px;
      text-decoration: underline;
    }

    .row {
      margin-bottom: calc(16vw / 3.6);

      &:last-child {
        margin-bottom: 0;
      }

      .inputRow, .btnRow {
        div {
          line-height: 40px;
          border: 1px solid rgba(246, 217, 170, 0.5);
          border-radius: 6px;
        }
      }

      .inputRow {
        display: flex;

        &:not(:last-child) {
          /*margin-bottom: 16px;*/
          margin-bottom: 8px;
        }

        div {
          flex: 1;
          font-size: 16px;
          color: #fff;
          text-align: right;
          padding-right: 15px;
          position: relative;

          &:not(:first-child) {
            margin-left: 9px;
          }

          input {
            font-size: 16px;
            color: #fff;
            text-align: right;
          }

          .coin-name {
            display: inline-block;
            border: none;
          }

          .coin-copy {
            display: inline-block;
          }

          .coin-address {
            border: none;
          }
        }

        .selected {
          font-size: 20px;
          font-weight: 600;
          color: #000000 !important;
          background-color: #F6D9AA;

          > div {
            font-size: 20px;
            font-weight: 600;
            color: #000;
          }
        }

        .claim {
          text-align: center;
          color: #000000;
          background-color: #F6D9AA;
          font-size: 18px;
          padding: 0;
        }
      }

      .secondaryRow {
        display: flex;
        justify-content: right;
        align-items: center;
        gap: 20px;
        line-height: 28px;
        padding-right: 15px;

        .title {
          font-weight: 400;
          font-size: 14px;
          color: #606466;
        }

        .amount {
          font-weight: 700;
          font-size: 22px;
          color: #D0D6D9;
        }
      }

      .btnRow {
        display: flex;

        div {
          flex: 1;
          text-align: center;
          font-size: 20px;
        }

        .depositBtn {
          background-color: #F6D9AA;
          color: #000;
          margin-right: 9px;
        }

        .withdrawBtn {
          color: #F6D9AA;
        }
      }

      .linkRow {
        display: flex;
        justify-content: space-between;
        margin-top: 5px;

        label {
          width: 100%;
          line-height: 30px;
          display: flex;
          justify-content: flex-start;

          input {
            font-size: 14px;
            color: #C4C4C4;
            width: 100%;
          }
        }

        .copy {
          font-size: 14px;
          color: rgba(246, 217, 170, 0.5);
          padding: 5px 0;
          border: 1px solid #818181;
          line-height: 20px;
          white-space: nowrap;
          display: flex;
          justify-content: center;
          width: 15vh;
        }
      }

      .safe-wallet-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        line-height: 40px;
        font-size: 20px;

        .input {
          border: 1px solid rgba(246, 217, 170, 0.5);
          border-radius: 6px;
          color: #fff;
          text-align: right;
          padding-right: 15px;
          width: calc(100vw - 130px - 32px - 10px);
        }

        .btn {
          width: 130px;
          background-color: #F6D9AA;
          text-align: center;
          border-radius: 6px;
          color: #000000;
          display: flex;

          .btn-inner {
            margin: 0 auto;
            display: flex;

            .icon {
              width: 22px;
              height: 22px;
              margin: 9px 10px 9px 0px;
            }
          }
        }
      }
    }

    .deposit {
      position: relative;
      left: 50%;
      transform: translateX(-50%);
      width: calc(325vw / 3.6);

      .activeEvent {
        position: absolute;
        top: -2.5vw;
        right: -4vw;
        font-size: 3.055vw;
        font-weight: 400;
        text-align: center;
        color: #FFFFFF;
        height: 5.55vw;
        line-height: 5.55vw;
        width: max-content;
        padding: 0 2vw;
        background: #FE1E28;
        border-radius: 3.888vw 3.888vw 3.888vw 0;
        z-index: 1;
      }

      .cashCount {
        font-size: 40px;
        line-height: 47px;
        color: #fff;
        text-align: center;
        /*margin-bottom: 30px;*/
        margin-bottom: 10px;
      }

      .caption {
        justify-content: center;
      }

      .row {
        margin: 0 auto;
        width: calc(325vw / 3.6);

        .depositRow {
          width: calc(325vw / 3.6);
          display: flex;
          flex-wrap: wrap;
          margin-bottom: calc(8vw / 3.6);

          &:last-of-type {
            margin-bottom: 0;
          }

          .depositItem {
            flex: 1;
            position: relative;
            background: rgba(75, 75, 75, 0.41);
            border-radius: 2.222vw;
            height: 11.75vw;
            font-size: 4.444vw;
            font-weight: 400;
            color: #fff;
          }

          .depositItem:nth-child(3n+1) {
            margin-left: 0;
          }

          .deposit-selected {
            color: #000000 !important;
            background-color: #F6D9AA;
          }

          > div {
            flex: 1;
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0;
            overflow: hidden;

            &:not(:first-child) {
              margin-left: 9px;
            }

            input {
              width: 100%;
              font-size: 16px;
              color: #fff;
              text-align: right;
            }

            .coin-name {
              display: inline-block;
              border: none;
            }

            .coin-copy {
              display: inline-block;
            }

            .coin-address {
              border: none;
            }

            .discountRange,
            .discountRange2,
            .discountRange3 {
              position: absolute;
              top: 0;
              right: 0;
              display: flex;
              align-items: center;
              justify-content: center;
              width: 11.111vw;
              min-width: 11.111vw;
              height: 3.611vw;
              margin-left: 1.111vw;
              font-size: 3.056vw;
              border: none;
              border-radius: 3.333vw 3.333vw 3.333vw 0;
              color: #ffffff;
              font-weight: 400;
            }

            .discountRange {
              background-color: #F23042;
            }

            .discountRange2 {
              background-color: #F23042;
            }

            .discountRange3 {
              height: 3.333vw;
              background-color: #F23042;
            }
          }
        }

        .gatewayRow {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          flex-wrap: wrap;
          gap: calc(12.3vw / 3.6);

          .gatewayItem {
            margin-top: calc(8vw / 3.6);
            flex: 0 0 calc((100% - calc(25vw / 3.6)) / 3);
            height: calc(34vw / 3.6);

            .gatewayRadio {
              position: relative;
              display: flex;
              justify-content: center;
              align-items: center;
              white-space: nowrap;
              width: 100%;
              height: 100%;

              .gatewayHot {
                background-color: red;
                width: 6.666vw;
                height: 6.666vw;
                border-radius: 3.333vw;
                position: absolute;
                top: -5.83vw;
                right: 5.83vw;
                font-size: 3.0555vw;
                color: #ffffff;
                padding: 1.111vw 0 0 0;
                text-align: center;
              }

              .inlineDiv {
                position: relative;
                height: 100%;
                width: 100%;
                border-radius: 2.222vw;
                background: rgba(75, 75, 75, 0.41);
                color: #fff;

                .gatewayDiscount {
                  position: absolute;
                  width: 16.66vw;
                  height: 5vw;
                  border-radius: 4.166vw;
                  margin-left: calc(3vw / 3.6);
                  color: #FE1E28;
                  font-size: calc(11vw / 3.6);
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  top: calc(-1vw / 3.6);
                  right: calc(-6vw / 3.6);
                }

                .gatewayTxt {
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  height: 100%;
                  font-size: calc(13vw / 3.6);
                  font-weight: 400;
                }

                .fire {
                  position: absolute;
                  right: 3vw;
                  width: max-content;
                  height: 9.5vw;
                  display: flex;
                  align-items: center;

                  img {
                    height: 4.166vw;
                  }
                }
              }

              .activeDiv {
                background: #F6D9AA;
                color: #000000;
              }
            }
          }

          .upiLogo {
            /*height: 25px;*/
            margin-left: 5px;
          }
        }

        .checkRow {
          margin-top: 20px;
          /*margin-bottom: 50px;*/
          font-size: 12px;
          line-height: 14px;
          color: #fff;

          label {
            height: 14px;
            margin-right: 15px;
          }

          div {
            display: flex;
            align-items: center;

            &:first-child {
              margin-bottom: 15px;
            }

            span {
              color: #F6D9AA;
            }
          }
        }

        .cash-box {
          background: rgba(246, 217, 170, 0.1);
          border-radius: 6px;
          line-height: 25px;
          padding: 10px 10px;
          text-align: center;

          .caption {
            color: #F6D9AA;
          }

          .cash {
            color: #FFFFFF;
          }
        }

        .transfer-box {
          text-align: center;
          position: relative;
          width: 70px;

          .transfer-inner {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);

            .img {
              width: 22px;
              height: 22px;
            }

            .text {
              color: #F6D9AA;
            }
          }
        }

        .nav {
          position: relative;
          left: 50%;
          transform: translate(-50%);
          width: calc(325vw / 3.6);
          height: calc(24vw / 3.6);
          display: flex;
          margin: 1.388vw 0 calc(4vw / 3.6) 0;
          border-radius: 6px;
          font-size: calc(14vw / 3.6);
          line-height: calc(24vw / 3.6);
          color: #ffffff;
          font-weight: 400;
          background: rgba(75, 75, 75, 0.41);

          .new {
            position: absolute;
            top: -2.6vw;
            right: -2.2vw;
            width: max-content;
            height: 5.556vw;
            z-index: 2;

            img {
              width: 100%;
            }
          }

          .nav-item {
            flex: 1;
            text-align: center;
            position: relative;

            .secureHint {
              position: absolute;
              top: -17px;
              width: 100%;
              height: calc(20vw / 3.6);
              color: #fff;
              display: flex;
              align-items: center;
              justify-content: flex-end;
              font-size: calc(12vw / 3.6);
              padding-bottom: calc(5vw / 3.6);
              border-top-left-radius: 6px;
              border-top-right-radius: 6px;
              transform: translate(calc(12vw / 3.6), 0);
            }

            .secureHintMask {
              position: absolute;
              background-color: #161616;
              top: 0;
              width: 100%;
              height: 8px;
              border-top-left-radius: 6px;
              border-top-right-radius: 6px;
            }

            .secureHintMaskSelected {
              background-color: #F6D9AA;
            }
          }

          .superSecureHint {
            position: absolute;
            width: 66.67%;
            right: 0;
            top: -17px;
            height: 17px;
            background-image: linear-gradient(45deg, #ff6a01, red);
            border-top-left-radius: 6px;
            border-top-right-radius: 6px;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 13px;
          }

          .active {
            position: relative;
            background: #F6D9AA;
            color: #543200;
            border-radius: 6px;
            z-index: 0;
          }
        }
      }

      .gateways-by-type {
        flex: 1;
        display: none;

        .how2UseUpi {
          margin-top: 2vw;
          font-size: calc(11vw / 3.6);
          line-height: calc(13vw / 3.6);
          height: calc(13vw / 3.6);
          font-weight: 400;
          text-align: left;
          color: #ffffff;
          display: flex;
          align-items: flex-end;
          justify-content: flex-start;

          img {
            height: calc(13vw / 3.6);
            margin-right: 1.5vw;
            margin-bottom: 0.2vw;
          }
        }

        .howtoDeposit {
          width: 160px;
          background-color: #000;
          color: #686868;
          font-size: 13px;
          top: 28px;
          padding: 2px;
          white-space: nowrap;

          a {
            color: red;
            font-weight: bold;
          }
        }
      }

      .gateways-by-type-active {
        display: block
      }

      .carlousel {
        margin-top: 3.333vw;
        height: 28.6vw;
      }

      .depositWord {
        position: relative;
        font-family: 'Inter';
        font-style: normal;
        font-weight: 700;
        font-size: calc(11vw / 3.6);
        line-height: calc(13vw / 3.6);
        color: #767676;
        margin-top: calc(16vw / 3.6);
        margin-bottom: calc(6vw / 3.6);

        .upiTeachingIcon {
          position: absolute;
          top: -1vw;
          right: -6vw;
          transform: translateY(-50%);
          z-index: 99;

          .img {
            position: relative;
            width: 20vw;
            height: 16.5vw;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            overflow: hidden;

            .redPoint {
              position: absolute;
              right: 4.7vw;
              top: 2.2vw;
              width: 2vw;
              height: 2vw;
              border-radius: 50%;
              background: radial-gradient(74.31% 74.31% at 31.38% 30.73%, #F9273A 0%, #982F39 100%);
            }

            img {
              width: 23.11vw;
              height: 23.26vw;
            }
          }
        }
      }

      .compute-deposit-discount {
        width: 100%;
        height: 60px;
        background-color: #000;
        border-radius: 10px;
        border: solid 1px #F6D9AA;
        margin-top: 10px;
        display: flex;
        overflow: hidden;
        padding: 5px;

        .depositTotalTable {
          width: 100%;
          font-size: 14px;
          color: #F6D9AA;
          border-radius: 2px;
          font-weight: bold;
        }

        .depositTotalTable td {
          background-color: #161616;
          text-align: center;
          padding: 2px 5px;
        }
      }

      .USDTTip {
        color: #767676;

        .title {
          font-size: 3.055vw;
          font-weight: 700;
          line-height: 3.611vw;
          padding-bottom: 1.2vw;
        }

        .rules {
          font-size: 2.777vw;
          font-weight: 500;
          line-height: 3.611vw;
        }
      }

      .bonus {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 700;
        color: #767676;
        font-size: calc(11vw / 3.6);
        line-height: calc(13vw / 3.6);
        margin-top: calc(16vw / 3.6);;
        margin-bottom: calc(6vw / 3.6);;
      }

      .discountTypeChoose {
        width: 100%;
        height: 10vw;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .choose {
          position: relative;
          width: 100%;
          height: 100%;
          background: rgba(75, 75, 75, 0.41);
          border-radius: 2.222vw;
          display: flex;
          justify-content: space-between;
          padding: 0 5vw;
          z-index: 3;

          .mask {
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            opacity: 0;
          }

          .typeDropList {
            position: absolute;
            left: 0;
            top: 8.5vw;
            width: 100%;
            max-height: 50vw;
            overflow-x: hidden;
            overflow-y: auto;
            background: #070707;
            border-radius: 0 0 2.222vw 2.222vw;
            z-index: 1;

            .item {
              font-family: Inter;
              font-size: calc(12vw / 3.6);
              font-weight: 500;
              text-align: left;
              color: #FFFFFF;
              height: 8.333vw;
              line-height: 8.333vw;
              padding: 0 5vw;
              background: none;
            }

            .active {
              background: #4B4B4B;
            }
          }

          .discountName {
            height: 10vw;
            line-height: 9.5vw;
            font-family: Inter;
            font-size: calc(12vw / 3.6);
            font-weight: 500;
            text-align: left;
            color: #FFFFFF;
          }

          .chooseDrop {
            height: 100%;
            display: flex;
            align-items: center;

            img {
              width: 4.722vw;
              height: auto;
            }
          }
        }
      }

      .deposit-step {
        position: absolute;
        height: 100dvh;
        width: 100vw;
        top: 0;
        left: 0;
        z-index: 8;
        background-color: rgba(0, 0, 0, 1);

        .cancel-btn {
          position: fixed;
          top: 20px;
          right: 20px;
          width: 38px;
          height: 38px;
          z-index: 8;
        }

        .deposit-step-img {
          width: 100%;
          overflow-y: scroll;

          img {
            width: 100%;
          }
        }
      }
    }

    .withdraw {
      position: relative;
      overflow: hidden;

      .balanceBox {
        width: 100%;
        height: 26.94vw;
        border: 1px solid #F6D9AA;
        border-radius: 2.22vw;
        padding: 2vw;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        position: relative;

        .historyPropBtn {
          position: absolute;
          right: 3vw;
          top: 3vw;
          color: #C8C8C8;
          border-bottom: 1px solid;
          padding-bottom: 0.2vw;
        }

        .balance-caption {
          //border: 1px solid red;
          color: #FFFFFF;
          font-size: 4.72vw;
          font-weight: 700;
        }

        .cashCount {
          //border: 1px solid red;
          color: #DEBC86;
          font-size: 6.388vw;
          font-weight: 700;
        }

        .gift-prompt {
          font-size: 12px;
          line-height: 14px;
          color: #686868;
          margin-bottom: 5px;
          margin-top: 5px;
          text-align: left;
        }
      }

      .tips {
        font-size: 12px;
        line-height: 14px;
        color: #686868;
        margin-bottom: 10px;
        margin-top: -10px;
      }

      .warning {
        color: #F6D9AA;
        margin-bottom: 25px;
        text-decoration: underline;
      }

      .row {
        margin-bottom: 20px;

        .operateRow {
          position: relative;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .label {
            font-size: 18px;
            line-height: 21px;
            color: #F6D9AA;
            width: calc(100vw - 100px - 30px - 40px);
          }

          .btn {
            width: 100px;
            font-size: 16px;
            line-height: 30px;
            color: rgba(246, 217, 170, 0.5);
            text-align: center;
            border: 1px solid rgba(246, 217, 170, 0.5);
            border-radius: 6px;
          }

          .tips-warn {
            position: absolute;
            right: 0;
            top: 35px;
            height: 42px;
            font-size: 12px;
            line-height: 14px;
            text-align: center;
            color: #ff0000;
            width: 200px;
            word-wrap: break-word;
            overflow-wrap: break-word;
            overflow-y: auto;
          }

          img {
            width: 25px;
            height: 25px;
          }
        }

        .inputRow {
          div:not(.input) {
            padding: 0;
            text-align: center;
          }

          input {
            width: 100%;
          }
        }

        .cash-box {
          background: rgba(246, 217, 170, 0.1);
          border-radius: 6px;
          line-height: 25px;
          padding: 10px 10px;
          text-align: center;

          .caption {
            color: #F6D9AA;
          }

          .cash {
            color: #FFFFFF;
          }
        }

        .transfer-box {
          text-align: center;
          position: relative;
          width: 70px;

          .transfer-inner {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);

            .img {
              width: 22px;
              height: 22px;
            }

            .text {
              color: #F6D9AA;
            }
          }
        }
      }

      .audit-message {
        color: #AA0000;
        font-size: 12px;
        line-height: 14px;
      }
    }

    .totalGet {
      font-family: 'Inter';
      font-style: normal;
      font-weight: 400;
      font-size: calc(14vw / 3.6);
      height: calc(17vw / 3.6);
      line-height: calc(17vw / 3.6);
      text-align: right;
      color: #EFEFEF;
    }

    .mt16 {
      margin-top: calc(16vw / 3.6);
    }

    .submit {
      position: relative;
      left: 50%;
      transform: translate(-50%);
      text-align: center;
      margin-top: calc(16vw / 3.6);
      margin-bottom: calc(30vw / 3.6);
      width: calc(325vw / 3.6);
      height: calc(40vw / 3.6);
      line-height: calc(40vw / 3.6);
      background: #F6D9AA;
      border-radius: 2.222vw;
      font-family: 'Inter';
      font-weight: 400;
      font-size: 5vw;
      letter-spacing: 0.01em;
      color: #000D2E;
    }

    .splitWithdrawBox {
      display: flex;
      flex-direction: column;
      margin-top: -6vw;

      .splitWithdrawTipBox {
        display: flex;
        align-items: center;
        gap: 2.222vw;
        margin-top: 5.277vw;
        position: relative;
        @keyframes openSplitWithdrawTipContentBox {
          0% {
            opacity: 0;
          }
          100% {
            opacity: 1;
          }
        }

        .splitWithdrawTipContentBox {
          position: absolute;
          padding: 2.2vw;
          font-size: 2.5vw;
          color: #DED9D9;
          font-weight: bold;
          background-color: rgb(55, 55, 55);
          border-radius: 2.222vw;
          max-width: 70.555vw;
          top: 7vw;
          z-index: 999;
          line-height: 4vw;
          animation: openSplitWithdrawTipContentBox 0.3s ease-in-out;

          .arrowIcon {
            position: absolute;
            z-index: 999;
            top: -1vw;
            left: 23vw;
            height: 4vw;
            width: 4vw;
            border-radius: 1vw;
            background-color: rgb(55, 55, 55);
            transform: rotateZ(45deg);
          }
        }

        .splitWithdrawTip {
          color: #ADADAD;
          font-size: 3.333vw;
          font-weight: bold;
        }

        .splitWithdrawTipIcon {
          height: 4.166vw;
          width: 4.166vw;
        }
      }

      .splitWithdrawOptionBox {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 4.444vw;
        width: 100%;
        gap: 3.333vw;
        flex-shrink: 0;
        overflow: hidden;

        .withdrawOptionItem {
          width: 100%;
          display: flex;
          align-items: center;
          gap: 3.775vw;
          flex-shrink: 0;
          height: auto;
          transition: all 0.2s ease-in-out;
          position: relative;

          .recommendBox {
            position: absolute;
            right: 11vw;
            top: 1.3vw;
            display: flex;
            align-items: center;
            gap: 1vw;

            .recommendIcon {
              height: 3.633vw;
              width: 3.633vw;
              position: relative;
              top: -0.5vw;
            }

            .recommend {
              color: rgba(255, 255, 255, 0.79);
              font-size: 2.777vw;
            }
          }

          .withdrawOptionItemCard {
            height: 13.888vw;
            width: 83.055vw;
            background-size: 100% 100%;
            flex-shrink: 0;
            display: flex;
            align-items: center;
            gap: 3.127vw;
            padding-left: 3.333vw;

            .withdrawOptionItemCardIcon {
              height: 6.666vw;
              width: 5.483vw;
              position: relative;
              top: -1vw;
            }

            .contentBox {
              height: 100%;
              flex: 1;
              display: flex;
              flex-direction: column;
              justify-content: center;
              gap: 2.333vw;

              .title {
                font-size: 3.333vw;
                font-weight: bold;
                color: #D0C3C3;
                display: flex;
                align-items: center;
                gap: 2vw;

                span {
                  color: #F6D9AA;
                  display: block;
                  position: relative;
                  top: 0.5vw;
                }
              }

              .largeWithdrawalsItemTip {
                font-size: 2.777vw;
                font-weight: bold;
                color: #8E0505;

              }
            }
          }

          .optionItemCardCheckIcon {
            position: relative;
            height: 2.777vw;
            width: 2.777vw;
            border-radius: 50%;
            background-color: #D9D9D9;

            .checked {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              height: calc(2.777vw / 2);
              width: calc(2.777vw / 2);
              border-radius: 50%;
              background-color: #0055FF;
            }
          }
        }
      }
    }
  }

  .usdtGuide {
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, .67);
    height: 100dvh;
    width: 100vw;
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;

    .usdt_Pop {
      width: calc(296.03vw / 3.6);
      height: calc(196vw / 3.6);
      border-radius: calc(15vw / 3.6);
      background: #1D1D1D;
      flex-direction: column;
      padding: calc(30vw / 3.6) 0;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .title {
        font-family: Inter;
        font-weight: 700;
        font-size: calc(17vw / 3.6);
        line-height: calc(20vw / 3.6);
        width: calc(243vw / 3.6);
        color: #ffffff;
      }

      .btn {
        width: calc(263.5vw / 3.6);
        height: calc(34.33vw / 3.6);
        line-height: calc(34.33vw / 3.6);
        border-radius: calc(7vw / 3.6);
        background: var(--primary-color);
        text-align: center;
        font-family: Inter;
        font-weight: 600;
        font-size: calc(14vw / 3.6);
        text-align: center;
        text-transform: capitalize;
        color: #000000;
      }
    }
  }
  .maskBg {
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, .6);
    height: 100dvh;
    width: 100vw;
    z-index: 999;
  }

  .pop-message-wrapper2 {
    position: absolute;
    top: 45%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 86.666vw;
    height: 58.333vw;
    background: radial-gradient(55.26% 69.13% at 56.09% 47.9%, #151715 0%, #202020 100%);
    border: 0.3vw solid #737373;
    border-radius: 4.166vw;
    z-index: 99999;

    p {
      color: #C4C4C4;
      //border: 1px solid red;
      font-size: 4.722vw;
      text-align: center;
    }

    .pop-message-content {
      position: relative;
      top: 56px;
      left: 50%;
      transform: translate(-50%);
      line-height: 25px;
      padding: 0 3vw;
      font-size: 18px;
      color: #F6D9AA;
      text-align: left;

      .close-pop-message {
        margin: 5.555vw 0;
        text-align: center;
        display: flex;
        justify-content: center;

        .close-pop-btn {
          display: block;
          border-radius: 2vw;
          //border: 1px solid #F2F2F2;
          width: 73.05vw;
          height: 9.44vw;
          background-image: linear-gradient(to right, #EFD6AD, #DAB67C);
          color: #000;
          text-align: center;
          line-height: 9.44vw;
        }
      }
    }
  }

  .payFutureMsg {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100dvh;
    overflow-x: hidden;
    overflow-y: auto;
    background: rgba(0, 0, 0, 0.60);
    z-index: 999;

    .msgCard {
      position: relative;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 86.667vw;
      height: 69.444vw;
      border: 0.33vw solid #737373;
      border-radius: 4.1667vw;
      background: radial-gradient(55.26% 69.13% at 56.09% 47.9%, #151715 0%, #202020 100%) /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */;
      text-align: center;
      padding: 10vw 0 0 0;

      .msg {
        margin: 0 auto 11.5vw auto;
        width: 70.55vw;
        font-family: Inter;
        font-weight: 500;
        font-size: 4.444vw;
        line-height: 6vw;
        color: #8d8d8d;
      }

      .button {
        margin: 5vw auto;
        width: 73.194vw;
        height: 9.444vw;
        line-height: 9.444vw;
        border-radius: 1.3888vw;
        background: linear-gradient(0deg, #F1DAB0, #F1DAB0),
        linear-gradient(90.85deg, #EFD6AD -10.06%, #DAB67C 116.71%);
        font-family: Inter;
        font-weight: 600;
        font-size: 4.166vw;
        text-align: center;
        text-transform: capitalize;
        color: #000000;
      }
    }
  }

  .noWithdrawalsOnWeekendsMarsk {
    height: 100dvh;
    width: 100vw;
    background-color: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .noWithdrawalsOnWeekendsPop {
    display: flex;
    flex-direction: column;
    align-items: center;
    //justify-content: space-around;
    justify-content: center;
    gap: 5vw;
    width: 86.66vw;
    height: 76.66vw;
    background-color: rgb(26, 28, 27);
    border: 1px solid rgba(115, 115, 115);
    border-radius: 4.166vw;

    .noWithdrawalsOnWeekendsPopTitle {
      color: #FFFFFF;
      font-size: 5.694vw;
      font-weight: 700;
      width: 69.44vw;
      text-align: center;
    }

    .ConfirmWithdrawal {
      width: 73.197vw;
      height: 9.444vw;
      border-radius: 1.388vw;
      color: #000000;
      font-size: 4.166vw;
      text-align: center;
      line-height: 9.444vw;
      background-image: linear-gradient(to right, #EFD6AD 0%, #DAB67C 100%);
      margin-top: 7vw;
      font-weight: 700;
    }

    .Cancel {
      width: 73.197vw;
      height: 9.444vw;
      border-radius: 1.388vw;
      color: #E1C18D;
      font-size: 4.166vw;
      border: 1px solid #E1C18D;
      text-align: center;
      line-height: 9.444vw;
      background-color: rgb(28, 29, 28);
      font-weight: 700;
    }
  }
}

.pop-message-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  height: 100dvh;
  width: 100vw;
  background-color: rgba(0, 0, 0, .9);
  z-index: 99999999;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 56px 0 72px 0;

  .pop-message-content {
    position: relative;
    left: 50%;
    transform: translate(-50%);
    line-height: 6.94vw;
    padding: 0 5.555vw;
    font-size: 5vw;
    color: #F6D9AA;
    text-align: left;

    .close-pop-message {
      margin: 5.55vw 0;
      text-align: center;

      .close-pop-btn {
        display: inline-block;
        padding: 0.6vw 5.55vw;
        border: 1px solid #F2F2F2;
        width: 27.777vw;
      }
    }
  }
}

.slots {
  .title {
    text-align: center;
    text-transform: capitalize;
    color: #FFFFFF;
    font-size: 5.833vw;
    font-weight: 700;
    letter-spacing: 0.03em;
  }

  .reward {
    color: #DEBC86;
    text-align: center;
    font-size: 10.555vw;
    font-weight: 700;
    margin: 4vw auto 5.5vw auto;
  }

  .sentence {
    width: 71.388vw;
    font-size: 4.722vw;
    font-weight: 400;
    text-align: left;
    color: #C4C4C4;
    margin: 4vw auto 22.3vw auto;
  }

  .desc {
    margin: 2.5vw auto;
    width: 71.722vw;
    font-size: 4.166vw;
    font-weight: 400;
    text-align: left;
    color: #939393;
  }
}

.showMore {
  text-align: center;

  img {
    width: 10px;
  }
}

.withdrawSetupBoxMask {
  position: fixed;
  top: 0;
  left: 0;
  height: 100dvh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.82);
  z-index: 999;

  .close {
    position: fixed;
    height: 4.05vw;
    width: 4.05vw;
    top: 60vw;
    left: 89vw;
  }

  .close2 {
    position: fixed;
    height: 4.05vw;
    width: 4.05vw;
    top: 72vw;
    left: 89vw;
  }

  .withdrawSetupBox {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    min-height: 126.26vw;
    height: max-content;
    width: 93.33vw;
    border-radius: 2.77vw;
    background-color: #242424;
    animation: showIn 0.3s ease-in-out forwards;
  }
}

.withdrawBanner {
  width: 91.111vw;
  height: 31.111vw;
  border-radius: 1.944vw;
  background-color: #2C2929;
  margin-top: 5vw;

  img {
    height: 100%;
    width: 100%;
  }
}

.deatilMask {
  height: 100dvh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.2);
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  top: 0;
  left: 0;
}

.QRCodeMask {
  height: 100dvh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.59);
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  top: 0;
  left: 0;

  .QRCodeBox {
    width: 86.666vw;
    height: 103.611vw;
    border: 1px solid rgb(115, 115, 115);
    border-radius: 4.166vw;
    background-color: rgb(29, 29, 29);
    position: relative;
    top: -8vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 5.833vw;
    animation: openBox 0.2s ease-in-out;

    .title {
      color: #FFFFFF;
      font-size: 5.833vw;
      font-weight: 700;
    }

    .tipBox {
      width: 76.28vw;
      height: 12.222vw;
      border-radius: 1.666vw;
      background-color: #090909;
      color: #888888;
      font-size: 3.6111vw;
      display: flex;
      align-items: center;
      padding-left: 5.622vw;
    }

    .QRCodeImgBox {
      height: 49.44vw;
      width: 49.44vw;
      border: 1px solid;

      .QRCode {
        height: 100%;
        width: 100%;
      }
    }

    .PaymentOnceOnly {
      color: #FF2121;
      font-size: 4.444vw;
      font-weight: 600;
    }

    .close {
      height: 4.333vw;
      width: 4.333vw;
      position: absolute;
      bottom: -7vw;
      left: 40vw;
    }
  }
}

@keyframes openBox {
  0% {
    transform: scale(0);
    opacity: 0; /* 开始时完全透明 */
  }
  50% {
    transform: scale(1.1); /* 在中间稍微放大一点，增加视觉冲击 */
    opacity: 1; /* 在中间变为完全不透明 */
  }
  100% {
    transform: scale(1); /* 结束时恢复到正常大小 */
    opacity: 1; /* 保持完全不透明 */
  }
}

.deatilBox {
  width: 86.66vw;
  height: 116.38vw;
  background-color: rgb(32, 32, 32);
  border: 1px solid #737373;
  border-radius: 4.16vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  @keyframes openBox {
    0% {
      transform: scale(0);
      opacity: 0; /* 开始时完全透明 */
    }
    50% {
      transform: scale(1.1); /* 在中间稍微放大一点，增加视觉冲击 */
      opacity: 1; /* 在中间变为完全不透明 */
    }
    100% {
      transform: scale(1); /* 结束时恢复到正常大小 */
      opacity: 1; /* 保持完全不透明 */
    }
  }

  .title {
    font-size: 5.833vw;
    color: #fff;
    margin-top: 4.8vw;
    display: flex;
    justify-content: center;
    height: 10vw;
  }

  .contentBox {
    padding: 2vw;
    overflow-x: hidden;
    overflow-y: auto;
    white-space: pre-wrap;
    padding: 0vw 7vw;
    //border: 1px solid red;
    height: 85.44vw;
    width: 100%;
  }

  .cancel {
    color: #000D2E;
    font-size: 5vw;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 1.388vw;
    height: 9.44vw;
    width: 73.197vw;
    background: linear-gradient(to right, #EFD6AD, #DAB67C);
    margin-top: 2vw;

  }
}

.McPayRemiderMask {
  height: 100dvh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.7);
  position: absolute;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;

  .McPayRemiderPop {
    width: 86.666vw;
    height: 62.5vw;
    box-sizing: border-box;
    border: 1px solid #737373;
    border-radius: 4.166vw;
    background: radial-gradient(55.26% 69.13% at 56.09% 47.9%, #151715 0%, #202020 100%) /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */;
    display: flex;
    flex-direction: column;
    align-items: center;

    .title {
      font-family: 'Inter';
      font-style: normal;
      font-weight: 700;
      font-size: 5.972vw;
      /* identical to box height */
      text-align: center;
      text-transform: capitalize;
      color: #D9D9D9;
      text-shadow: 0px 6px 6px rgba(0, 0, 0, 0.6);
      margin-top: 6.722vw;
    }

    .describe {
      font-family: 'Inter';
      font-style: normal;
      font-weight: 400;
      font-size: 4.722vw;
      color: #9E9E9E;
      margin-top: 4.666vw;
      width: 68.5vw;
    }

    .optionBox {
      margin-top: 8.611vw;
      display: flex;
      align-items: center;
      gap: 2.3vw;

      .helpBtn {
        height: 9.536vw;
        width: 36.666vw;
        font-size: 3.888vw;
        font-weight: 600;
        font-family: 'Inter';
        font-style: normal;
        text-align: center;
        text-transform: capitalize;
      }

      .newOrderBtn {
        height: 9.536vw;
        width: 36.666vw;
        font-size: 3.888vw;
        font-weight: 600;
        font-family: 'Inter';
        font-style: normal;
        text-align: center;
        text-transform: capitalize;
      }
    }
  }
}

@keyframes showIn {
  0% {
    position: fixed;
    bottom: -135vw;
  }
  100% {
    position: fixed;
    bottom: 63px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Account/index.vue